import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  TextField,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Menu,
  Tooltip
} from '@mui/material';
import Select from '@mui/material/Select';
import React, { createRef, useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import staticData from '../../../resources/static.json';
import './SubjectTracking.scss';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import DJ2Form from './configurableformprovider';
import { setMessage } from 'src/store/Message';
import Popover from '@mui/material/Popover';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import moment from 'moment';
import { ReactComponent as BookmarkIcon } from './bookmark_visits.svg';
import { useCRFForms } from './useCRFForms';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { hideLoader, showLoader } from 'src/store/Loader';
import Loader from '../../common/Loader';
import { useTrailNotebookCRF } from '../PatientTrialNoteBook/useTrailNotebookCRF';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useGetQueriesQuery } from 'src/services/Queries';
import ViewQuery from '../SubjectTracking/PrescreenDetails/ViewQuery';
import { archLevel } from 'src/data/config';
import { allQueriesArr } from './CRFFormModalTranscripts';
import { useUtil } from 'src/components/hooks/useUtil';
import { ContentLoader } from '@pihealth/common-ui-library';
import { setVistCRFData } from 'src/store/CrfFormsAction';
import dayjs from 'dayjs';

const CRFFormModal: React.FunctionComponent<any> = ({
  handleCloseModel,
  formConfig,
  parent_id,
  isUpdate,
  setisUpdate,
  selectedVisit,
  editRowData,
  setselectedVisit,
  seteditRowData,
  bookMarkKey,
  bookMarkField,
  exitValue,
  setExitValue,
  setcurrentAddedEvent,
  setcurrentEditEventData,
  setisAddCliked,
  individualEventData
}: any) => {
  const { checkPermission } = usePermissionWrapper();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const visitCRFsData = useAppSelector(state => state.CRFForms.vistCRFData);
  const user = useAppSelector(state => `${state.user.user?.firstName} ${state.user.user?.lastName}`);
  const { handleError } = useUtil();
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<any>(null);
  const [currentDataEntryFormId, SetcurrentDataEntryFormId] = useState<any>(null);
  const [openQueryDialog, setOpenQueryDialog] = useState<boolean>(false);
  const [openRaiseQuery, setOpenRaiseQuery] = useState(false);
  const [queryObj, setQueryObj] = useState<any>({});
  const [allQueries, setAllQueries] = useState<allQueriesArr[]>([]);
  const [raisedQuerys, setRaisedQuerys] = useState<allQueriesArr[]>([]);
  const [showQuerys, setShowQuerys] = useState<allQueriesArr[]>([]);
  const [sectionQuerys, setSectionQuerys] = useState<allQueriesArr[]>([]);
  const [openFieldAuditTrail, setOpenFieldAuditTrail] = useState(false);
  const QueryMenu = staticData.query_menu.filter(
    (ele: any) => checkPermission(ele.permission) && (ele.level === 'all' || ele.level === archLevel)
  );
  const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
  const [showFields, setShowFields] = useState<any>({});
  const [isSectionQuery, setIsSectionQuery] = useState(false);
  const [showFieldKeys, setShowFieldKeys] = useState('');
  const { getPatientsDetails, getPatientsDetailsData, getPatientsDetailsIsLoading } = useTrailNotebookCRF();
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [isFieldChanged, setisFieldChanged] = useState(false);
  const [eventSpecificData, setEventSpecifiData] = useState(individualEventData);
  useEffect(() => {
    if (getPatientsDetailsData && editRowData) {
      // const findVisit = getPatientsDetailsData.find((item: any) => item.study_visit.id == editRowData.visit_id);
      const findVisit: any = getPatientsDetailsData.find((item: any) =>
        item.crf_data.find((ele: any) => ele.result.event_uuid == editRowData.event_uuid)
      );
      setselectedVisit(null);
      setselectedVisit(findVisit);
    }
  }, [getPatientsDetailsData, editRowData]);

  useEffect(() => {
    (async () => {
      dispatch(showLoader());
      if (selectedVisit?.visit_crf.OID && editRowData) {
        await selectCRFDataByID({
          data: {
            OID: selectedVisit?.visit_crf.OID,
            patient_id: parent_id,
            event_uuid: editRowData?.event_uuid,
            visit_id: selectedVisit?.study_visit.id,
            creation_source: editRowData?.creation_source ? editRowData?.creation_source : 'TSDA'
          },
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry
        });
      }
      dispatch(hideLoader());
    })();
  }, [editRowData]);

  const [dataEntryNum, setdataEntryNum] = useState(null);
  useEffect(() => {
    if (selectedVisit) {
      let lastEventData = null;
      if (selectedVisit.crf_data.length > 0) {
        lastEventData = selectedVisit.crf_data[0].result;
      }
      if (editRowData) {
        setdataEntryNum(editRowData.event_number);
      } else {
        setdataEntryNum(lastEventData ? lastEventData.event_number + 1 : 1);
      }
    }
  }, [editRowData]);

  const {
    createCRFFormDataFunc,
    createCRFFormData,
    createCRFFormDataIsError,
    createCRFFormDataIsSuccess,
    createCRFFormDataIsLoading,
    createCRFFormDataError,
    updateCRFFormDataFunc,
    updateCRFFormData,
    updateCRFFormDataIsError,
    updateCRFFormDataIsSuccess,
    updateCRFFormDataIsLoading,
    updateCRFFormDataError,
    getVisitLinkedCRFs,
    getVisitLinkedCRFsData,
    getVisitLinkedCRFsIsLoading,
    deleteAssociation,
    deleteAssociationEvent,
    deleteAssociationIsSuccess,
    deleteAssociationEventIsSuccess,
    deleteAssociationIsError,
    deleteAssociationEventIsError,
    getCheckboxValue,
    getRadioButtonValue,
    getCRFEvent,
    selectCRFData,
    getAddedKeyData,
    shouldHide,
    selectCRFDataByID,
    selectCRFDataByIDData,
    selectCRFDataByIDIsLoading,
    getCRFEventIsLoading
  } = useCRFForms();
  const getAllVisitLinkCRFAndStoreInRedux = async () => {
    let holeCRFData: any = {};
    for (const crf of getVisitLinkedCRFsData) {
      const result: any = await getCRFEvent({
        data: {
          patient_id: parent_id,
          visit_id: selectedVisit.study_visit.id,
          OID: crf.OID,
          crf_form_version: crf.published_version
        },
        study_id: studyId,
        site_id: selectedSite,
        country: selectedCountry
      });
      if (result?.data) {
        const strig = `${parent_id}-${selectedVisit.study_visit.id}-${crf.OID}-${crf.published_version}-${studyId}`;
        holeCRFData = { ...holeCRFData, [strig]: result?.data };
      }
    }
    dispatch(setVistCRFData(holeCRFData));
  };
  useEffect(() => {
    if (getVisitLinkedCRFsData?.length) {
      getAllVisitLinkCRFAndStoreInRedux();
    }
  }, [getVisitLinkedCRFsData?.length]);
  useEffect(() => {
    setEventSpecifiData(selectCRFDataByIDData);
  }, [selectCRFDataByIDData]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleListItemClick = (index: any) => {
    setSelectedIndex(index);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const { data: codeListData } = useGetCodeListDataQuery('CRFEVNTSTS');

  const bindDefaultValuesToForm = (clonedObj: any) => {
    clonedObj.sections.map((section: any) => {
      section.rows.map((row: any) => {
        row.fields.map((field: any) => {
          field.isCustomForm = true;
          if (field.cmp == 'checkbox' && field?.default_value && field?.default_value.length > 0) {
            let values = {};
            field?.default_value.map((val: any) => {
              values = { ...values, [val]: true };
            });
            // field.default_value = values;
          } else if (
            field?.cmp == 'select' &&
            field?.default_value &&
            field?.data_dictionary_values &&
            field?.data_dictionary_values.length > 0
          ) {
            if (field?.multiple) {
              const values = [];
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.default_value.includes(field?.data_dictionary_values[i].value)) {
                  values.push({
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  });
                }
              }
              field.default_value = values;
            } else {
              let values: any = field?.default_value;
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.data_dictionary_values[i].value == field?.default_value) {
                  values = {
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  };
                  break;
                }
              }
              field.default_value = values;
            }
          }
        });
      });
    });
    return clonedObj;
  };

  const getDefualtValuesAndRules = (formJsonMeta: any) => {
    const selectedRowData: any =
      isUpdate && eventSpecificData && eventSpecificData[0]
        ? eventSpecificData[0]
        : selectedVisit?.crf_data?.find((item: any) => item.result?.event_number == editRowData?.event_number);
    let initialValues = {};
    let rules = {};
    if (formJsonMeta?.sections) {
      const formData = formJsonMeta.sections.flatMap((section: any) => section.rows.flatMap((row: any) => row.fields));
      const checkDefaultwithCurrentDateAndTime = (field: any) => {
        if (field.default_value) {
          return field.default_value;
        } else if (
          (field.type === 'date' && field.is_current_date) ||
          (field.type === 'date_time' && field.is_current_date_time)
        ) {
          return dayjs(new Date());
        } else if (field.type === 'time' && field.is_current_time) {
          return dayjs(new Date()).format('hh:mm a');
        }
        return null;
      };
      const initValues = formData.reduce(
        (acc: any, cur: any) => ({ ...acc, [cur.key]: checkDefaultwithCurrentDateAndTime(cur) }),
        {}
      );
      initialValues = { ...initValues, first_setup_values: true };
      let mockRulesObj: any = {};
      formData.map((item: any) => {
        if (item?.cmp == 'date' && item.allow_partial == true) {
          const temp = {
            partialDate: {
              required: item.required ? true : false,
              errorText: 'Partial Date cannot be empty'
            }
          };
          mockRulesObj = { ...mockRulesObj, [item.key]: temp };
        }
        if (
          item?.required &&
          !(item?.cmp == 'date' && item.allow_partial == true) &&
          !(selectedRowData?.result?.creation_source == 'FICS' && item.fsource_object_id)
        ) {
          const makeObj = {
            required: {
              value: true,
              errorText: 'Required'
            }
          };
          mockRulesObj = { ...mockRulesObj, [item.key]: makeObj };
        }
        if (item?.cmp == 'date' && !item.allow_partial) {
          mockRulesObj = {
            ...mockRulesObj,
            [item.key]: { ...mockRulesObj?.[item.key], date: { value: true, errorText: 'Invalid Data' } }
          };
        }
      });
      rules = mockRulesObj;
    }
    return { initialValues, rules };
  };

  /**
   * ADD NEW LINK CRF Functionality Start
   */

  const formRefs: any = useRef([]);

  useEffect(() => {
    if (selectedVisit) {
      getVisitLinkedCRFs({
        visit_id: selectedVisit?.study_visit?.id,
        visit_name: selectedVisit?.unscheduled_visit ? selectedVisit?.unscheduled_visit : null,
        mrn: selectedVisit?.unscheduled_visit ? parent_id : null,
        study_id: studyId,
        site_id: selectedSite,
        country: selectedCountry
      });
    }
  }, [isUpdate, selectedVisit]);

  const { data: crfASSOCIATIONData, isLoading: crfASSOCIATIONIsLoading } = useGetCodeListDataQuery('CRFASSOCIATION');

  const [crfAssociation, setCrfAssociation] = useState([]);
  useEffect(() => {
    if (crfASSOCIATIONData) {
      const vals: any = [];
      crfASSOCIATIONData.map((ass: any) => {
        vals.push(ass.code_list_value);
      });
      setCrfAssociation(vals);
    }
  }, [crfASSOCIATIONData]);

  const [listOfcurrentSelectedLinkedCRFs, setlistOfcurrentSelectedLinkedCRFs] = useState<any>(null);

  const [tempField, setTempField] = useState(1);
  const onDJ2Change = (data: any, fieldConfig: any) => {
    let parentBookMarkData: any = null;
    let chailBookMarkData: any = null;
    let associationTermData: any = null;
    let nativeAssociationTermData: any = null;
    let parentCheckBoxBookmarkValue: any = null;
    let parentRadioBookmarkValue: any = null;

    const updatedData = listOfcurrentSelectedLinkedCRFs.map((obj: any, index: any) => {
      let find: any = null;
      let chaildCheckBoxBookmarkValue = null;
      let chaildRadioBookmarkValue = null;
      const existingRules: any = obj?.firstRules
        ? { ...obj?.firstRules }
        : obj.rules
        ? { ...obj.rules }
        : { ...obj.rulesCopy };

      if (index == 0) {
        if (bookMarkKey && data[bookMarkKey] != null && data[bookMarkKey] != '') {
          parentBookMarkData = data[bookMarkKey];
          if (bookMarkField?.cmp == 'checkbox') {
            parentCheckBoxBookmarkValue = getCheckboxValue(bookMarkField, parentBookMarkData);
          }
          if (bookMarkField?.cmp == 'radio') {
            parentRadioBookmarkValue = getRadioButtonValue(bookMarkField, parentBookMarkData);
          }
        }
        const formData = formConfig?.meta.sections.flatMap((section: any) =>
          section.rows.flatMap((row: any) => row.fields)
        );
        const show_hide_fieldsdata: any[] = [];
        formData.map((field: any) => {
          if (field['show_hide_value'] && field['show_hide']) {
            const is_show_hide_req_valid = shouldHide(field, data);
            show_hide_fieldsdata.push({ ...field, is_show_hide_req_valid });
          }
        });
        // show_hide_fieldsdata.map((prop: any) => {
        //   if (prop.is_show_hide_req_valid == false) {
        //     data[prop.key] = null;
        //   }
        // });
        Object.keys(existingRules).map((key: any) => {
          show_hide_fieldsdata.map((prop: any) => {
            if (prop.key === key && prop.is_show_hide_req_valid == false) {
              delete existingRules[key];
              data[prop.key] = null;
            }
          });
        });
      } else {
        const formData = obj?.associationTerm?.meta.sections.flatMap((section: any) =>
          section.rows.flatMap((row: any) => row.fields)
        );

        const show_hide_fieldsdata: any[] = [];
        formData?.map((field: any) => {
          if (field['show_hide_value'] && field['show_hide']) {
            const is_show_hide_req_valid = shouldHide(field, data);
            show_hide_fieldsdata.push({ ...field, is_show_hide_req_valid });
          }
        });
        // show_hide_fieldsdata.map((prop: any) => {
        //   if (prop.is_show_hide_req_valid == false) {
        //     data[prop.key] = null;
        //   }
        // });
        Object.keys(existingRules).map((key: any) => {
          show_hide_fieldsdata.map((prop: any) => {
            if (prop.key === key && prop.is_show_hide_req_valid == false) {
              delete existingRules[key];
              data[prop.key] = null;
            }
          });
        });

        if (formData) {
          find = formData.find((item: any) => item?.bookmark);
        }
        if (find && data[find.key] != null && data[find.key] != '') {
          chailBookMarkData = data[find.key];
          if (find?.cmp == 'checkbox') {
            chaildCheckBoxBookmarkValue = getCheckboxValue(find, chailBookMarkData);
          }
          if (find?.cmp == 'radio') {
            chaildRadioBookmarkValue = getRadioButtonValue(find, chailBookMarkData);
          }
        }

        associationTermData = parentBookMarkData
          ? bookMarkField?.cmp == 'date'
            ? bookMarkField?.type == 'date_time'
              ? moment(new Date(parentBookMarkData)).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`)
              : moment(parentBookMarkData).format(`${userPreferedDateFormat.toUpperCase()}`)
            : bookMarkField?.cmp == 'time'
            ? parentBookMarkData.toString()
            : bookMarkField?.cmp == 'select' &&
              bookMarkField?.multiple &&
              typeof parentBookMarkData === 'object' &&
              parentBookMarkData?.find((item: any) => 'label' in item)
            ? parentBookMarkData?.map((value: any) => value?.label).toString()
            : bookMarkField?.cmp == 'select' && typeof parentBookMarkData === 'object'
            ? parentBookMarkData?.label
            : bookMarkField?.cmp == 'checkbox'
            ? parentCheckBoxBookmarkValue
            : bookMarkField?.cmp == 'radio'
            ? parentRadioBookmarkValue
            : parentBookMarkData.toString()
          : bookMarkField && bookMarkField?.fieldKey == 'label'
          ? bookMarkField?.title
          : null;
        nativeAssociationTermData = chailBookMarkData
          ? find?.cmp == 'date'
            ? find?.type == 'date_time'
              ? moment(new Date(chailBookMarkData)).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`)
              : moment(chailBookMarkData).format(`${userPreferedDateFormat.toUpperCase()}`)
            : find?.cmp == 'time'
            ? chailBookMarkData.toString()
            : find?.cmp == 'select' &&
              find?.multiple &&
              typeof chailBookMarkData === 'object' &&
              chailBookMarkData?.find((item: any) => 'label' in item)
            ? chailBookMarkData?.key.map((value: any) => value.label).toString()
            : find?.cmp == 'select' && typeof chailBookMarkData === 'object'
            ? chailBookMarkData?.label
            : find?.cmp == 'checkbox'
            ? chaildCheckBoxBookmarkValue
            : find?.cmp == 'radio'
            ? chaildRadioBookmarkValue
            : find?.fieldKey == 'label'
            ? find?.title
            : chailBookMarkData.toString()
          : find && find?.fieldKey == 'label'
          ? find?.title
          : null;
      }

      // && obj.associationTerm.OID === data.eventData.OID
      if (index === data.formIndex) {
        let bookMarksObj = {};
        //if (data.formId == listOfcurrentSelectedLinkedCRFs[0].event_number) {
        bookMarksObj = {
          ...bookMarksObj,
          associationTermData: associationTermData ? associationTermData : obj.associationTermData
        };
        //}
        const massociationTermEventData = {
          ...obj.associationTermEventData,
          label: nativeAssociationTermData,
          value: nativeAssociationTermData
        };
        const moptionsData: any = [];
        if (obj?.optionsData) {
          obj.optionsData.map((item: any) => {
            if (massociationTermEventData.id == item.id && massociationTermEventData.OID == item.OID) {
              moptionsData.push({
                ...item,
                label: nativeAssociationTermData,
                value: nativeAssociationTermData
              });
            } else {
              moptionsData.push(item);
            }
          });
        }

        // if (data.formId == obj.event_number) {
        bookMarksObj = { ...bookMarksObj, nativeAssociationTermData };
        //}
        if (fieldConfig.error) {
          for (const section of obj.associationTerm.meta.sections) {
            for (const row of section.rows) {
              for (const field of row.fields) {
                if (fieldConfig.key === field.key) {
                  field.helperText = '';
                  field.error = false;
                  break;
                }
              }
            }
          }
        }
        setalreadySelectedEvents([...alreadySelectedEvents, massociationTermEventData]);
        const firstRules = obj?.firstRules
          ? { ...obj?.firstRules }
          : obj.rules
          ? { ...obj.rules }
          : { ...obj.rulesCopy };
        if (index == 0) {
          setcurrentEditEventData({
            ...obj,
            firstRules,
            rules: existingRules,
            isError: false,
            ...bookMarksObj,
            associationTermEventData: massociationTermEventData,
            optionsData: moptionsData,
            initialValues: { ...obj.initialValues, ...data, first_setup_values: false }
          });
        }
        return {
          ...obj,
          firstRules,
          rules: existingRules,
          isError: false,
          ...bookMarksObj,
          associationTermEventData: massociationTermEventData,
          optionsData: moptionsData,
          initialValues: { ...obj.initialValues, ...data, first_setup_values: false },
          isBookMarkField: find
        };
      } else {
        let bookMarksObj = {};
        //if (data.formId == listOfcurrentSelectedLinkedCRFs[0].event_number) {
        bookMarksObj = {
          ...bookMarksObj,
          associationTermData: associationTermData ? associationTermData : obj.associationTermData
        };
        //}
        return {
          ...obj,
          isError: false,
          ...bookMarksObj,
          isBookMarkField: find
        };
      }
    });
    if (!exitValue) {
      setExitValue(true);
    }
    setisFieldChanged(true);
    setlistOfcurrentSelectedLinkedCRFs(updatedData);
    setcurrentAddedEvent(updatedData);
  };

  const setUpParentFormData = async (formMetaData: any) => {
    const { initialValues, rules } = getDefualtValuesAndRules(formMetaData.meta);
    const formRef: any = createRef();
    formRefs.current.push(formRef);
    setlistOfcurrentSelectedLinkedCRFs([
      {
        initialValues,
        rules,
        event_number: `linkCRF${0}`,
        native_association: null,
        native_crf_type: null,
        associationTerm: formMetaData,
        formRefObj: formRef
      }
    ]);
    setcurrentAddedEvent([
      {
        initialValues,
        rules,
        event_number: `linkCRF${0}`,
        native_association: null,
        native_crf_type: null,
        associationTerm: formMetaData,
        formRefObj: formRef
      }
    ]);
  };

  const [alreadySelectedEvents, setalreadySelectedEvents] = useState<any>([]);
  const handleChangeAssociation = async (event: any, event_number: any, crf_type: any) => {
    const modifiedData: any = [];
    let findlinkData: any = null;
    let currentLinkCRF = null;
    if (event.target.value != '' || event.target.name == 'associationTerm') {
      for (let i = 0; i < listOfcurrentSelectedLinkedCRFs.length; i++) {
        if (
          i != 0 &&
          listOfcurrentSelectedLinkedCRFs[i].event_number == event_number &&
          crf_type === listOfcurrentSelectedLinkedCRFs[i].native_crf_type
        ) {
          if (event.target.name == 'associationTerm') {
            if (currentSelectedLinkedCRF?.formRefObj?.current) {
              currentSelectedLinkedCRF.formRefObj.current.submit((data: any) => {
                const foundLinkCRF = listOfcurrentSelectedLinkedCRFs.find(
                  (item: any) => item.event_number === currentSelectedLinkedCRF.event_number
                );
                if (foundLinkCRF && data.errors) {
                  foundLinkCRF.isAppError = true;
                }
                if (foundLinkCRF && data.success) {
                  foundLinkCRF.appRecords = data.records;
                }
              });
            }
            setcurrentSelectedLinkedCRF(null);
            if (
              listOfcurrentSelectedLinkedCRFs[i].native_crf_type != null &&
              listOfcurrentSelectedLinkedCRFs[i].native_association != null
            ) {
              findlinkData = getVisitLinkedCRFsData.find(
                (obj: any) => obj.OID == listOfcurrentSelectedLinkedCRFs[i].native_crf_type
              );

              if (isUpdate && !event_number.toString().includes('linkCRF')) {
                const selectedRowData: any =
                  isUpdate && eventSpecificData && eventSpecificData[0]
                    ? eventSpecificData[0]
                    : selectedVisit.crf_data.find((item: any) => item.result.event_number == editRowData.event_number);
                const findEventData = selectedRowData.linked_crfs_data.find(
                  (item: any) => item.event_number === event_number && item.native_crf_type === crf_type
                );
                dispatch(showLoader());
                const result: any = await selectCRFData({
                  data: {
                    OID: listOfcurrentSelectedLinkedCRFs[i].native_crf_type,
                    patient_id: parent_id,
                    crf_form_version: findEventData.crf_form_version,
                    visit_id: findEventData.visit_id,
                    id: findEventData.id
                  },
                  study_id: studyId,
                  site_id: selectedSite,
                  country: selectedCountry
                });
                dispatch(hideLoader());
                const resultData: any = result.data[0];
                const fsourceFields: any = [];
                const clonedObj: any = JSON.parse(JSON.stringify(findlinkData));
                clonedObj.meta.sections.map((section: any) => {
                  section.rows.map((row: any) => {
                    row.fields.map((field: any) => {
                      let values = {
                        ...findEventData
                      }[field?.key];
                      if (!listOfcurrentSelectedLinkedCRFs[i].initialValues?.first_setup_values) {
                        values = {
                          ...findEventData,
                          ...getAddedKeyData(listOfcurrentSelectedLinkedCRFs[i].initialValues)
                        }[field?.key];
                      }
                      if (resultData.result.creation_source == 'FICS' && field.fsource_object_id) {
                        field.disableField = true;
                        fsourceFields.push(field.key);
                      }
                      if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                        const valArr: any = [];
                        Object.keys(values).map((valkey: any) => {
                          if (values[valkey]) {
                            valArr.push(valkey);
                          }
                        });
                        field.default_value = valArr;
                      } else if (field.cmp == 'select') {
                        if (values && Object.keys(values).length > 0) {
                          if (field?.multiple) {
                            const multiselectVal = values?.key;
                            field.default_value = multiselectVal;
                          } else {
                            field.default_value = values;
                          }
                        } else {
                          if (field?.multiple) {
                            field.default_value = [];
                          } else {
                            field.default_value = null;
                          }
                        }
                      } else {
                        field.default_value = findEventData[field?.key];
                      }
                    });
                  });
                });
                const { initialValues, rules } = getDefualtValuesAndRules(clonedObj.meta);
                const rulesCopy: any = { ...rules };
                for (const i of fsourceFields) {
                  if (Object.keys(rules).includes(i)) {
                    delete rulesCopy[i];
                  }
                }
                modifiedData.push({
                  ...listOfcurrentSelectedLinkedCRFs[i],
                  initialValues: {
                    ...initialValues,
                    file_data: resultData.result?.file_data ? resultData.result?.file_data : [],
                    event_uuid: resultData.result?.event_uuid ? resultData.result?.event_uuid : null
                  },
                  rulesCopy,
                  associationTerm: clonedObj,
                  linkedData: resultData
                });
                currentLinkCRF = {
                  ...listOfcurrentSelectedLinkedCRFs[i],
                  initialValues: {
                    ...initialValues,
                    file_data: resultData.result?.file_data ? resultData.result?.file_data : [],
                    event_uuid: resultData.result?.event_uuid ? resultData.result?.event_uuid : null
                  },
                  rulesCopy,
                  associationTerm: clonedObj,
                  linkedData: resultData
                };
              } else {
                let clonedMetaData = JSON.parse(JSON.stringify(findlinkData));
                if (listOfcurrentSelectedLinkedCRFs[i]?.initialValues) {
                  clonedMetaData.meta.sections.map((section: any) => {
                    section.rows.map((row: any) => {
                      row.fields.map((field: any) => {
                        const values = listOfcurrentSelectedLinkedCRFs[i].initialValues?.[field?.key];
                        if (field.cmp == 'checkbox' && values && Object.keys(values).length) {
                          const valArr: any = [];
                          Object.keys(values).map((valkey: any) => {
                            if (values[valkey]) {
                              valArr.push(valkey);
                            }
                          });
                          field.default_value = valArr;
                        } else if (field.cmp == 'select') {
                          if (values && Object.keys(values).length) {
                            if (field?.multiple) {
                              const multiselectVal = values?.key ? values?.key : values;
                              field.default_value = multiselectVal;
                            } else {
                              field.default_value = values;
                            }
                          } else {
                            if (field?.multiple) {
                              field.default_value = [];
                            } else {
                              field.default_value = null;
                            }
                          }
                        } else {
                          field.default_value = listOfcurrentSelectedLinkedCRFs[i].initialValues?.[field?.key];
                        }
                      });
                    });
                  });
                } else {
                  const modifiedMetaData = await bindDefaultValuesToForm(clonedMetaData.meta);
                  clonedMetaData = { ...clonedMetaData, meta: modifiedMetaData };
                }

                const { initialValues, rules } = getDefualtValuesAndRules(clonedMetaData.meta);

                const bookMarkInitData = listOfcurrentSelectedLinkedCRFs[0]?.initialValues[bookMarkKey];
                currentLinkCRF = {
                  ...listOfcurrentSelectedLinkedCRFs[i],
                  initialValues: { ...initialValues, ...listOfcurrentSelectedLinkedCRFs[i].initialValues },
                  rules,
                  associationTerm: clonedMetaData,
                  associationTermData:
                    bookMarkKey &&
                    listOfcurrentSelectedLinkedCRFs[0]?.initialValues &&
                    (bookMarkInitData || bookMarkField?.fieldKey == 'label')
                      ? bookMarkField?.cmp == 'date'
                        ? bookMarkField?.type == 'date_time'
                          ? moment(new Date(bookMarkInitData)).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`)
                          : moment(bookMarkInitData).format(`${userPreferedDateFormat.toUpperCase()} `)
                        : bookMarkField?.cmp == 'time'
                        ? bookMarkInitData.toString()
                        : bookMarkField?.cmp == 'checkbox'
                        ? getCheckboxValue(bookMarkField, bookMarkInitData)
                        : bookMarkField?.cmp == 'radio'
                        ? getRadioButtonValue(bookMarkField, bookMarkInitData)
                        : bookMarkField && bookMarkField?.fieldKey == 'label'
                        ? bookMarkField?.title
                        : bookMarkField?.cmp == 'select' &&
                          bookMarkField?.multiple &&
                          typeof bookMarkInitData === 'object' &&
                          bookMarkInitData?.length &&
                          bookMarkInitData?.find((item: any) => 'label' in item)
                        ? bookMarkInitData?.map((value: any) => value?.label)?.toString()
                        : bookMarkField?.cmp == 'select' &&
                          typeof bookMarkInitData === 'object' &&
                          bookMarkInitData?.label
                        ? bookMarkInitData?.label
                        : bookMarkInitData != undefined
                        ? bookMarkInitData?.toString()
                        : null
                      : `${dataEntryNum} (${moment(new Date()).format(`${userPreferedDateFormat.toUpperCase()}`)})`,
                  native_association: listOfcurrentSelectedLinkedCRFs[i].native_association,
                  linked_crf_type: selectedVisit.visit_crf.OID,
                  linked_association: crfAssociation.find(
                    (obj: any) => obj.trim() != listOfcurrentSelectedLinkedCRFs[i].native_association.trim()
                  )
                };
                modifiedData.push(currentLinkCRF);
              }
            } else {
              modifiedData.push(listOfcurrentSelectedLinkedCRFs[i]);
            }
          } else if (event.target.name == 'associationTermEvent') {
            if (currentSelectedLinkedCRF?.formRefObj?.current) {
              currentSelectedLinkedCRF.formRefObj.current.submit((data: any) => {
                const foundLinkCRF = listOfcurrentSelectedLinkedCRFs.find(
                  (item: any) => item.event_number === currentSelectedLinkedCRF.event_number
                );
                if (foundLinkCRF && data.errors) {
                  foundLinkCRF.isAppError = true;
                }
                if (foundLinkCRF && data.success) {
                  foundLinkCRF.appRecords = data.records;
                }
              });
            }
            setcurrentSelectedLinkedCRF(null);
            const targetedData = event.target.value;
            const selectedEventData = targetedData.reverse()[0];
            const multiSelectedVals = targetedData.filter((item: any, itemIndex: any) => {
              if (itemIndex != 0) {
                return item;
              }
            });
            const filterDiseletedData: any = [];
            alreadySelectedEvents.filter((eventData: any) => {
              const find = multiSelectedVals.find((multiVal: any) => {
                if (eventData.label == multiVal.label && eventData.id == multiVal.id && eventData.OID == multiVal.OID) {
                  return true;
                }
              });

              if (!find) {
                filterDiseletedData.push(eventData);
              }
            });

            if (selectedEventData?.value != 'NEW' && selectedEventData?.id != 'newId') {
              setalreadySelectedEvents([...filterDiseletedData, selectedEventData]);
            } else {
              setalreadySelectedEvents([...filterDiseletedData]);
            }
            findlinkData = getVisitLinkedCRFsData.find(
              (obj: any) => obj.OID == listOfcurrentSelectedLinkedCRFs[i].native_crf_type
            );
            let selectedRowData: any = null;
            let findEventData: any = null;
            let clonedObj: any = JSON.parse(JSON.stringify(findlinkData));
            const fsourceFields: any = [];
            if (selectedEventData?.value != 'NEW' && selectedEventData?.id != 'newId') {
              dispatch(showLoader());
              const result: any = await selectCRFData({
                data: {
                  OID: listOfcurrentSelectedLinkedCRFs[i].native_crf_type,
                  patient_id: parent_id,
                  crf_form_version: selectedEventData.crf_form_version,
                  visit_id: selectedEventData.visit_id,
                  id: selectedEventData.id
                },
                study_id: studyId,
                site_id: selectedSite,
                country: selectedCountry
              });
              dispatch(hideLoader());
              selectedRowData = result.data[0];
              findEventData = selectedRowData.result;
              clonedObj.meta.sections.map((section: any) => {
                section.rows.map((row: any) => {
                  row.fields.map((field: any) => {
                    const values = findEventData[field?.key];
                    if (selectedRowData.result.creation_source == 'FICS' && field.fsource_object_id) {
                      field.disableField = true;
                      fsourceFields.push(field.key);
                    }
                    if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                      const valArr: any = [];
                      Object.keys(values).map((valkey: any) => {
                        if (values[valkey]) {
                          valArr.push(valkey);
                        }
                      });
                      field.default_value = valArr;
                    } else if (field.cmp == 'select') {
                      if (values && Object.keys(values).length) {
                        if (field?.multiple) {
                          const multiselectVal = values?.key;
                          field.default_value = multiselectVal;
                        } else {
                          field.default_value = values;
                        }
                      } else {
                        if (field?.multiple) {
                          field.default_value = [];
                        } else {
                          field.default_value = null;
                        }
                      }
                    } else {
                      field.default_value = findEventData[field?.key];
                    }
                  });
                });
              });
              listOfcurrentSelectedLinkedCRFs[i].initialValues = {
                ...listOfcurrentSelectedLinkedCRFs[i]?.initialValues,
                ...findEventData
              };
            } else {
              const modifiedMetaData = await bindDefaultValuesToForm(clonedObj.meta);
              clonedObj = { ...clonedObj, meta: modifiedMetaData };
            }

            if (listOfcurrentSelectedLinkedCRFs[i]?.initialValues) {
              clonedObj.meta.sections.map((section: any) => {
                section.rows.map((row: any) => {
                  row.fields.map((field: any) => {
                    const values = listOfcurrentSelectedLinkedCRFs[i].initialValues?.[field?.key];
                    if (field.cmp == 'checkbox' && values && Object.keys(values).length) {
                      const valArr: any = [];
                      Object.keys(values).map((valkey: any) => {
                        if (values[valkey]) {
                          valArr.push(valkey);
                        }
                      });
                      field.default_value = valArr;
                    } else if (field.cmp == 'select') {
                      if (values && Object.keys(values).length) {
                        if (field?.multiple) {
                          const multiselectVal = values?.key ? values?.key : values;
                          field.default_value = multiselectVal;
                        } else {
                          field.default_value = values;
                        }
                      } else {
                        if (field?.multiple) {
                          field.default_value = [];
                        } else {
                          field.default_value = null;
                        }
                      }
                    } else {
                      field.default_value = listOfcurrentSelectedLinkedCRFs[i].initialValues?.[field?.key];
                    }
                  });
                });
              });
            } else {
              const modifiedMetaData = await bindDefaultValuesToForm(clonedObj.meta);
              clonedObj = { ...clonedObj, meta: modifiedMetaData };
            }
            const { initialValues, rules } = getDefualtValuesAndRules(clonedObj.meta);
            const rulesCopy: any = { ...rules };
            for (const i of fsourceFields) {
              if (Object.keys(rules).includes(i)) {
                delete rulesCopy[i];
              }
            }
            const bookMarkInitData = listOfcurrentSelectedLinkedCRFs[0]?.initialValues[bookMarkKey];
            currentLinkCRF = {
              ...listOfcurrentSelectedLinkedCRFs[i],
              initialValues,
              rulesCopy,
              associationTerm: clonedObj,
              associationTermData:
                bookMarkKey &&
                listOfcurrentSelectedLinkedCRFs[0]?.initialValues &&
                (bookMarkInitData || bookMarkField?.fieldKey == 'label')
                  ? bookMarkField?.cmp == 'date'
                    ? bookMarkField?.type == 'date_time'
                      ? moment(new Date(bookMarkInitData)).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`)
                      : moment(bookMarkInitData).format(`${userPreferedDateFormat.toUpperCase()} `)
                    : bookMarkField?.cmp == 'time'
                    ? bookMarkInitData.toString()
                    : bookMarkField?.cmp == 'checkbox'
                    ? getCheckboxValue(bookMarkField, bookMarkInitData)
                    : bookMarkField?.cmp == 'radio'
                    ? getRadioButtonValue(bookMarkField, bookMarkInitData)
                    : bookMarkField && bookMarkField?.fieldKey == 'label'
                    ? bookMarkField?.title
                    : bookMarkField?.cmp == 'select' &&
                      bookMarkField?.multiple &&
                      typeof bookMarkInitData === 'object' &&
                      bookMarkInitData?.length &&
                      bookMarkInitData?.find((item: any) => 'label' in item)
                    ? bookMarkInitData?.map((value: any) => value?.label)?.toString()
                    : bookMarkField?.cmp == 'select' && typeof bookMarkInitData === 'object' && bookMarkInitData?.label
                    ? bookMarkInitData?.label
                    : bookMarkInitData != undefined
                    ? bookMarkInitData?.toString()
                    : null
                  : `${dataEntryNum} (${moment(new Date()).format(`${userPreferedDateFormat.toUpperCase()}`)})`,
              native_association: listOfcurrentSelectedLinkedCRFs[i].native_association,
              linked_crf_type: selectedVisit.visit_crf.OID,
              linked_association: crfAssociation.find(
                (obj: any) => obj.trim() != listOfcurrentSelectedLinkedCRFs[i].native_association.trim()
              ),
              eventData: findEventData,
              linkedData: selectedRowData,
              associationTermEventData: selectedEventData,
              isNewlyAdded: true,
              isError: false
            };
            modifiedData.push(currentLinkCRF);
            setisFieldChanged(true);
          } else if (event.target.name == 'native_crf_type') {
            let resultdata: any = {};
            if (
              visitCRFsData?.[
                `${parent_id}-${selectedVisit.study_visit.id}-${event.target.value}-${event.target.version}-${studyId}`
              ]?.length
            ) {
              resultdata =
                visitCRFsData?.[
                  `${parent_id}-${selectedVisit.study_visit.id}-${event.target.value}-${event.target.version}-${studyId}`
                ];
            } else {
              dispatch(showLoader());
              const result: any = await getCRFEvent({
                data: {
                  patient_id: parent_id,
                  visit_id: selectedVisit.study_visit.id,
                  OID: event.target.value,
                  crf_form_version: event.target.version
                },
                study_id: studyId,
                site_id: selectedSite,
                country: selectedCountry
              });
              resultdata = result.data;
              dispatch(hideLoader());
            }
            const optionsData: any = [];
            if (resultdata && resultdata?.length > 0) {
              await resultdata.map((obj: any) => {
                const mockData = obj.result;
                const chailBookmarkdata =
                  mockData?.bookmark_key &&
                  (mockData?.bookmark_key_value || mockData?.bookmark_cmp?.fieldKey == 'label')
                    ? mockData?.bookmark_cmp?.cmp == 'date'
                      ? mockData?.bookmark_cmp?.type == 'date_time'
                        ? moment(new Date(mockData?.bookmark_key_value)).format(
                            `${userPreferedDateFormat.toUpperCase()} h:mm A`
                          )
                        : moment(mockData?.bookmark_key_value).format(`${userPreferedDateFormat.toUpperCase()}`)
                      : mockData?.bookmark_cmp?.cmp == 'time'
                      ? mockData?.bookmark_key_value.toString()
                      : mockData?.bookmark_cmp?.fieldKey && mockData?.bookmark_cmp?.fieldKey == 'label'
                      ? mockData?.bookmark_cmp?.title
                      : mockData?.bookmark_cmp?.cmp == 'select' &&
                        mockData?.bookmark_cmp?.multiple &&
                        typeof mockData.bookmark_key_value === 'object' &&
                        'key' in mockData.bookmark_key_value
                      ? mockData?.bookmark_key_value?.key.map((value: any) => value.label).toString()
                      : mockData?.bookmark_cmp?.cmp == 'select' && typeof mockData.bookmark_key_value === 'object'
                      ? mockData.bookmark_key_value?.label
                      : mockData?.bookmark_cmp?.cmp == 'checkbox'
                      ? getCheckboxValue(mockData.bookmark_cmp, mockData.bookmark_key_value)
                      : mockData?.bookmark_cmp?.cmp == 'radio'
                      ? getRadioButtonValue(mockData.bookmark_cmp, mockData.bookmark_key_value)
                      : mockData.bookmark_key_value.toString()
                    : `${mockData.event_number} (${moment(new Date(mockData.date_of_entry)).format(
                        `${userPreferedDateFormat.toUpperCase()}`
                      )})`;
                const find = alreadySelectedEvents.find((multiVal: any) => {
                  if (
                    chailBookmarkdata == multiVal.label &&
                    mockData.id == multiVal.id &&
                    event.target.value == multiVal.OID
                  ) {
                    return true;
                  }
                });

                if (!find) {
                  optionsData.push({
                    ...obj.result,
                    label: chailBookmarkdata,
                    value: chailBookmarkdata,
                    key: obj.result.id
                  });
                }
              });
            }
            optionsData.push({
              label: '+ NEW',
              value: 'NEW',
              key: 'newId',
              id: 'newId'
            });
            modifiedData.push({
              ...listOfcurrentSelectedLinkedCRFs[i],
              [event.target.name]: event.target.value,
              optionsData,
              isError: false
            });
          } else {
            modifiedData.push({
              ...listOfcurrentSelectedLinkedCRFs[i],
              [event.target.name]: event.target.value,
              isError: false
            });
          }
        } else {
          modifiedData.push(listOfcurrentSelectedLinkedCRFs[i]);
        }
      }

      setlistOfcurrentSelectedLinkedCRFs(modifiedData);
      setcurrentAddedEvent(modifiedData);
      if (currentLinkCRF) {
        setcurrentSelectedLinkedCRF(currentLinkCRF);
      }
    }
  };

  useEffect(() => {
    if (getVisitLinkedCRFsIsLoading || getPatientsDetailsIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [getVisitLinkedCRFsIsLoading, getPatientsDetailsIsLoading]);

  useEffect(() => {
    (async () => {
      dispatch(showLoader());
      if (formConfig && !getVisitLinkedCRFsIsLoading && !crfASSOCIATIONIsLoading) {
        const clonedObj: any = JSON.parse(JSON.stringify(formConfig));

        if (isUpdate && (selectedVisit?.crf_data.length > 0 || (eventSpecificData && eventSpecificData[0]))) {
          const newArray: any = [];
          const existEventsData: any = [];
          const selectedRowData: any =
            isUpdate && eventSpecificData && eventSpecificData[0]
              ? eventSpecificData[0]
              : selectedVisit?.crf_data?.find((item: any) => item.result.event_number == editRowData.event_number);
          if (selectedRowData) {
            clonedObj.meta.sections.map((section: any) => {
              section.rows.map((row: any) => {
                row.fields.map((field: any) => {
                  field.helperText = '';
                  field.error = false;
                  const values = selectedRowData.result[field?.key];
                  if (selectedRowData.result.creation_source == 'FICS' && field.fsource_object_id) {
                    field.disableField = true;
                  }
                  if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                    const valArr: any = [];
                    Object.keys(values).map((valkey: any) => {
                      if (values[valkey]) {
                        valArr.push(valkey);
                      }
                    });
                    field.default_value = valArr;
                  } else if (field.cmp == 'select') {
                    if (values && Object.keys(values).length > 0) {
                      if (field?.multiple) {
                        const multiselectVal = values?.key;
                        // const valArr: any = [];
                        // multiselectVal.map((valkey: any) => {
                        //   valArr.push(valkey?.code_list_value_code || valkey?.value);
                        // });
                        field.default_value = multiselectVal;
                      } else {
                        field.default_value = values;
                      }
                    } else {
                      if (field?.multiple) {
                        field.default_value = [];
                      } else {
                        field.default_value = null;
                      }
                    }
                  } else {
                    field.default_value = selectedRowData.result[field?.key];
                  }
                });
              });
            });
            SetcurrentDataEntryFormId(selectedRowData?.result?.id);
            const { initialValues, rules } = getDefualtValuesAndRules(clonedObj.meta);
            const formRef: any = createRef();
            formRefs.current.push(formRef);
            newArray.push({
              initialValues: {
                ...initialValues,
                file_data: selectedRowData.result.file_data,
                event_uuid: selectedRowData.result?.event_uuid
              },
              rules,
              event_number: selectedRowData.result.event_number,
              native_association: null,
              native_crf_type: null,
              associationTerm: clonedObj,
              formRefObj: formRef,
              formId: selectedRowData.result.event_number,
              eventData: selectedRowData?.result
            });
            if (selectedRowData.linked_crfs_data.length > 0 && getVisitLinkedCRFsData && crfASSOCIATIONData) {
              await selectedRowData.linked_crfs_data.map(async (item: any) => {
                const findMetaObjRaw = getVisitLinkedCRFsData.find((obj: any) => obj.OID === item.native_crf_type);
                if (findMetaObjRaw) {
                  const findMetaObj: any = JSON.parse(JSON.stringify(findMetaObjRaw));
                  const fsourceFields: any = [];
                  findMetaObj.meta.sections.map((section: any) => {
                    section.rows.map((row: any) => {
                      row.fields.map((field: any) => {
                        field.helperText = '';
                        field.error = false;
                        const values = item[field?.key];
                        if (item.creation_source == 'FICS' && field.fsource_object_id) {
                          fsourceFields.push(field.key);
                        }
                        if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                          const valArr: any = [];
                          Object.keys(values).map((valkey: any) => {
                            if (values[valkey]) {
                              valArr.push(valkey);
                            }
                          });
                          field.default_value = valArr;
                        } else if (field.cmp == 'select') {
                          if (values && Object.keys(values).length > 0) {
                            if (field?.multiple) {
                              const multiselectVal = values?.key;
                              // const valArr: any = [];
                              // multiselectVal.map((valkey: any) => {
                              //   valArr.push(valkey?.code_list_value_code || valkey?.value);
                              // });
                              field.default_value = multiselectVal;
                            } else {
                              field.default_value = values;
                            }
                          } else {
                            if (field?.multiple) {
                              field.default_value = [];
                            } else {
                              field.default_value = null;
                            }
                          }
                        } else {
                          field.default_value = item[field?.key];
                        }
                      });
                    });
                  });
                  const { initialValues, rules } = getDefualtValuesAndRules(findMetaObj.meta);
                  const rulesCopy: any = { ...rules };
                  for (const i of fsourceFields) {
                    if (Object.keys(rules).includes(i)) {
                      delete rulesCopy[i];
                    }
                  }
                  const associationTermData =
                    selectedRowData.result?.bookmark_key &&
                    (selectedRowData.result?.bookmark_key_value || bookMarkField?.fieldKey == 'label')
                      ? bookMarkField?.cmp == 'date'
                        ? bookMarkField?.type == 'date_time'
                          ? moment(new Date(selectedRowData.result.bookmark_key_value)).format(
                              `${userPreferedDateFormat.toUpperCase()} h:mm A`
                            )
                          : moment(selectedRowData.result.bookmark_key_value).format(
                              `${userPreferedDateFormat.toUpperCase()}`
                            )
                        : bookMarkField?.cmp == 'time'
                        ? selectedRowData.result.bookmark_key_value.toString()
                        : bookMarkField?.cmp == 'checkbox'
                        ? getCheckboxValue(bookMarkField, selectedRowData.result.bookmark_key_value)
                        : bookMarkField?.cmp == 'radio'
                        ? getRadioButtonValue(bookMarkField, selectedRowData.result.bookmark_key_value)
                        : bookMarkField && bookMarkField?.fieldKey == 'label'
                        ? bookMarkField?.title
                        : bookMarkField?.cmp == 'select' &&
                          bookMarkField?.multiple &&
                          typeof selectedRowData.result.bookmark_key_value === 'object' &&
                          'key' in selectedRowData.result.bookmark_key_value
                        ? selectedRowData.result?.bookmark_key_value?.key.map((value: any) => value.label).toString()
                        : bookMarkField?.cmp == 'select' &&
                          typeof selectedRowData.result.bookmark_key_value === 'object'
                        ? selectedRowData.result.bookmark_key_value?.label
                        : `${
                            selectedRowData.result.event_number
                          } ${selectedRowData.result.bookmark_key_value.toString()}`
                      : `${selectedRowData.result.event_number} (${moment(
                          new Date(selectedRowData.result.date_of_entry)
                        ).format(`${userPreferedDateFormat.toUpperCase()}`)})`;

                  const formData = findMetaObj.meta.sections.flatMap((section: any) =>
                    section.rows.flatMap((row: any) => row.fields)
                  );

                  const find = formData.find((item: any) => item?.bookmark);
                  const nativeAssociationTermData =
                    item?.bookmark_key && (item?.bookmark_key_value || item?.bookmark_cmp?.fieldKey == 'label')
                      ? find?.cmp == 'checkbox'
                        ? getCheckboxValue(find, item.bookmark_key_value)
                        : find?.cmp == 'radio'
                        ? getRadioButtonValue(find, item.bookmark_key_value)
                        : find && find.fieldKey == 'label'
                        ? item?.bookmark_cmp?.title
                        : find?.cmp == 'date'
                        ? find?.type == 'date_time'
                          ? moment(new Date(item?.bookmark_key_value)).format(
                              `${userPreferedDateFormat.toUpperCase()} h:mm A`
                            )
                          : moment(item?.bookmark_key_value).format(`${userPreferedDateFormat.toUpperCase()}`)
                        : find?.cmp == 'time'
                        ? item?.bookmark_key_value.toString()
                        : find?.cmp == 'select' &&
                          find?.multiple &&
                          typeof item.bookmark_key_value === 'object' &&
                          'key' in item.bookmark_key_value
                        ? item?.bookmark_key_value?.key.map((value: any) => value.label).toString()
                        : find?.cmp == 'select' && typeof item.bookmark_key_value === 'object'
                        ? item.bookmark_key_value?.label
                        : item.bookmark_key_value.toString()
                      : `${item.event_number} (${moment(new Date(item.date_of_entry)).format(
                          `${userPreferedDateFormat.toUpperCase()}`
                        )})`;

                  const formRef: any = createRef();
                  formRefs.current.push(formRef);
                  newArray.push({
                    formId: item.event_number,
                    initialValues: { ...initialValues, file_data: item.file_data, event_uuid: item?.event_uuid },
                    rulesCopy,
                    event_number: item.event_number,
                    native_association: item.native_association.trim(),
                    native_crf_type: item.native_crf_type,
                    linked_crf_type: item.linked_crf_type.trim(),
                    linked_association: item.linked_association.trim(),
                    associationTerm: findMetaObj,
                    formRefObj: formRef,
                    eventData: item,
                    associationTermData,
                    native_associationTermData: nativeAssociationTermData
                  });
                  existEventsData.push({
                    label: nativeAssociationTermData,
                    value: nativeAssociationTermData,
                    key: item.id,
                    ...item
                  });
                }
              });
              setalreadySelectedEvents([...alreadySelectedEvents, ...existEventsData]);
            }
            //
          }
          setlistOfcurrentSelectedLinkedCRFs(newArray);
          setTempField(tempField + 1);
          setcurrentAddedEvent(newArray);
          dispatch(hideLoader());
        } else {
          setUpParentFormData({ ...formConfig, meta: bindDefaultValuesToForm(clonedObj.meta) });
          dispatch(hideLoader());
        }
      }
      // setTempField(tempField + 1);
    })();
  }, [
    editRowData,
    isUpdate,
    formConfig,
    // selectedVisit,
    getVisitLinkedCRFsData,
    getVisitLinkedCRFsIsLoading,
    crfASSOCIATIONIsLoading,
    crfASSOCIATIONData,
    eventSpecificData
  ]);

  // const addnewLinkRowFocus: any = useRef();
  const fireOnclick = (id: any) => {
    const ele: any = document.getElementById(id);
    if (ele) {
      ele.focus();
      //addnewLinkRowFocus?.current?.focus();
    } else {
      setTimeout(() => {
        fireOnclick(id);
      }, 500);
    }
  };

  const [currentSelectedLinkedCRF, setcurrentSelectedLinkedCRF] = useState<any>(null);

  const handlAddNewLinkCRFBtn = () => {
    const formRef = createRef();
    formRefs.current.push(formRef);
    const clonedData = listOfcurrentSelectedLinkedCRFs;
    setlistOfcurrentSelectedLinkedCRFs([
      ...listOfcurrentSelectedLinkedCRFs,
      {
        formId: `linkCRF${listOfcurrentSelectedLinkedCRFs.length + 1}`,
        event_number: `linkCRF${listOfcurrentSelectedLinkedCRFs.length + 1}`,
        native_association: null,
        native_crf_type: null,
        associationTerm: null,
        formRefObj: formRef
      }
    ]);
    fireOnclick(`AssociationlinkCRF${clonedData.length + 1}`);
    if (!exitValue) {
      setExitValue(true);
    }
  };

  // useEffect(() => {
  //   addnewLinkRowFocus?.current?.focus();
  // }, [listOfcurrentSelectedLinkedCRFs]);

  const [errorIndex, seterrorIndex] = useState<any>([]);
  const checkType = (obj: any) => {
    for (const keys of Object.keys(obj)) {
      if (obj?.[keys]?.type === 'required') {
        return true;
      }
    }
    return false;
  };
  const submitFormAndGetData = (linkCRF: any) => {
    const tempData: any = {};
    if (linkCRF?.formRefObj?.current != null) {
      linkCRF.formRefObj.current.submit((data: any) => {
        if (data.errors && checkType(data.records)) {
          tempData.isAppError = true;
        } else if (data.errors) {
          tempData.isAppError = true;
          tempData.invalidData = true;
        }
        if (data.success && data.records) {
          tempData.appRecords = data.records;
        }
      });
    } else {
      tempData.isAppError = linkCRF.isAppError;
      tempData.appRecords = linkCRF.appRecords;
    }
    // Manual Validation
    if (linkCRF?.associationTerm?.meta?.sections) {
      const fields = extractFields(linkCRF?.associationTerm?.meta?.sections);
      fields.forEach((element: any) => {
        if (element.type === 'time') {
          if (linkCRF.initialValues?.[element.key] === 'Invalid Time') {
            tempData.isAppError = true;
            tempData.invalidData = true;
          } else if (element.required && !linkCRF.initialValues?.[element.key]) {
            tempData.isAppError = true;
          } else if (
            linkCRF.initialValues?.[element.key] &&
            !moment(linkCRF.initialValues?.[element.key], 'h:mm A', true).isValid()
          ) {
            tempData.isAppError = true;
          }
        }
      });
    }
    return tempData;
  };
  const submitAllForms = async () => {
    dispatch(showLoader());
    let reqPayload: any = null;
    let validation = false;
    const noDataEntryForms: any = [];
    const emptyFormRows: any = [];
    let filterErrorList: any = listOfcurrentSelectedLinkedCRFs;
    let invalidData = false;
    listOfcurrentSelectedLinkedCRFs.map((linkCRF: any, formindex: number) => {
      const tempData = submitFormAndGetData(linkCRF);
      if (tempData.isAppError) {
        validation = true;
        emptyFormRows.push(linkCRF);
        seterrorIndex([...errorIndex, formindex]);
        let prevErrorThere = false;
        filterErrorList = filterErrorList.map((obj: any, listindex: any) => {
          if (listindex === formindex && !prevErrorThere) {
            prevErrorThere = true;
            return { ...obj, isError: true };
          } else {
            return obj;
          }
        });
        setlistOfcurrentSelectedLinkedCRFs(null);
        setlistOfcurrentSelectedLinkedCRFs(filterErrorList);
        dispatch(hideLoader());
        if (tempData.invalidData) {
          invalidData = true;
        }
        return;
      }
      if (
        tempData.appRecords &&
        (formindex == 0 ||
          (linkCRF?.nativeAssociationTermData && linkCRF?.nativeAssociationTermData.trim() !== '') ||
          (linkCRF?.native_associationTermData && linkCRF?.native_associationTermData.trim() !== '') ||
          !linkCRF?.isBookMarkField)
      ) {
        let reqPayload1 = {};
        const dataObj: any = JSON.parse(JSON.stringify(tempData.appRecords));
        if (Object.keys(dataObj).length > 0) {
          Object.keys(dataObj).map((dataKey: any) => {
            if (dataObj[dataKey] == null) {
              delete dataObj[dataKey];
            }
            if (
              dataObj[dataKey] &&
              typeof dataObj[dataKey] == 'object' &&
              Object.keys(dataObj[dataKey]).includes('allow_partial_day')
            ) {
              if (Object.values(dataObj[dataKey]).filter((item: any) => item == null || item == '').length > 2) {
                delete dataObj[dataKey];
              }
            }
            /** this condition for multi select values and checkbox to send as key value pair start */
            if (Array.isArray(dataObj[dataKey])) {
              const formData = linkCRF?.associationTerm?.meta.sections.flatMap((section: any) =>
                section.rows.flatMap((row: any) => row.fields)
              );
              let find: any = null;
              if (formData) {
                find = formData.find((item: any) => item.key == dataKey);
              }
              if (dataObj[dataKey].length > 0 && find && find.cmp == 'select' && find?.multiple) {
                dataObj[dataKey] = { key: dataObj[dataKey] };
              } else if (dataObj[dataKey].length > 0 && find && find.cmp == 'checkbox') {
                let values = {};
                dataObj[dataKey].map((val: any) => {
                  values = { ...values, [val]: true };
                });
                dataObj[dataKey] = values;
              } else if (dataObj[dataKey].length == 0) {
                delete dataObj[dataKey];
              }
            }
            /** this condition for multi select values and checkbox to send as key value pair end */
          });
        }

        /**section docs maping submitted files start */
        const sectionAttchements = dataObj?.section_attchements;
        const prevFilesData = dataObj?.file_data;
        const removedFiles: any = dataObj?.removedFiles ? dataObj?.removedFiles : [];
        delete dataObj?.section_attchements;
        delete dataObj?.file_data;
        delete dataObj?.removedFiles;
        delete dataObj?.event_uuid;

        const fileData: any = [];
        if (prevFilesData) {
          prevFilesData.map((file: any) => {
            if (!removedFiles.includes(file.file_master_id)) {
              fileData.push({
                file_id: file.file_master_id,
                ctms_raw_file_name: file.ctms_raw_file_name,
                section_name: file.section_name,
                section_number: file.section_number
              });
            }
          });
        }
        if (sectionAttchements) {
          sectionAttchements.map((section: any) => {
            if (section?.submitedFiles) {
              section?.submitedFiles.map((file: any) => {
                if (!removedFiles.includes(file.id)) {
                  fileData.push({
                    file_id: file.id,
                    ctms_raw_file_name: file.ctms_raw_file_name,
                    section_name: section.sectionData.section_name,
                    section_number: section.sectionData.sectionId
                  });
                }
              });
            }
          });
        }
        /**section docs maping submitted files end */

        //For parent form
        if (formindex == 0) {
          delete dataObj?.type;
          delete dataObj?.formId;
          delete dataObj?.formIndex;
          delete dataObj?.eventData;
          delete dataObj?.linked_association;
          delete dataObj?.native_association;
          delete dataObj?.first_setup_values;
          const selectedRowData: any =
            isUpdate && eventSpecificData && eventSpecificData[0]
              ? eventSpecificData[0]
              : selectedVisit?.crf_data?.find((item: any) => item?.result?.event_number == editRowData?.event_number);

          if (Object.keys(dataObj).length > 0) {
            reqPayload1 = {
              OID: selectedVisit.visit_crf.OID,
              patient_id: parent_id,
              visit_id: selectedVisit.study_visit.id,
              date_of_entry: moment().format(),
              event_status: selectedIndex.trim(),
              crf_form_version: selectedVisit.visit_crf.published_version,
              data_json: dataObj,
              linked_crfs_data: [],
              file_data: fileData,
              creation_source: selectedRowData?.result?.creation_source
                ? selectedRowData.result.creation_source
                : 'TSDA',
              event_uuid: selectedRowData?.result?.event_uuid
            };
            reqPayload = reqPayload1;
          } else {
            validation = true;
            dispatch(hideLoader());
            noDataEntryForms.push(linkCRF.associationTerm.OID);
            let prevErrorThere = false;
            filterErrorList = filterErrorList.map((obj: any, listindex: any) => {
              if (listindex === formindex && !prevErrorThere) {
                prevErrorThere = true;
                return { ...obj, isError: true };
              } else {
                return obj;
              }
            });
            setlistOfcurrentSelectedLinkedCRFs(null);
            setlistOfcurrentSelectedLinkedCRFs(filterErrorList);
          }
        } else {
          delete dataObj?.type;
          delete dataObj?.formId;
          delete dataObj?.formIndex;
          const linkedAssociation = dataObj?.linked_association;
          const nativeAssociation = dataObj?.native_association;
          const eventData = dataObj?.eventData;
          delete dataObj?.eventData;
          delete dataObj?.linked_association;
          delete dataObj?.native_association;
          delete dataObj?.first_setup_values;
          const prevLinkedData: any = reqPayload?.linked_crfs_data ? reqPayload?.linked_crfs_data : [];
          if (Object.keys(dataObj).length > 0) {
            if (eventData) {
              prevLinkedData.push({
                id: eventData.id,
                OID: linkCRF?.associationTerm.OID,
                crf_form_version: linkCRF?.associationTerm.published_version,
                date_of_entry: moment().format(),
                data_json: dataObj,
                native_association: nativeAssociation,
                linked_association: linkedAssociation,
                native_crf_type: linkCRF?.associationTerm.OID,
                linked_crf_type: selectedVisit.visit_crf.OID,
                file_data: fileData,
                creation_source: linkCRF?.eventData?.creation_source ? linkCRF?.eventData?.creation_source : 'TSDA',
                event_uuid: linkCRF?.eventData?.event_uuid
              });
            } else {
              prevLinkedData.push({
                OID: linkCRF?.associationTerm.OID,
                crf_form_version: linkCRF?.associationTerm.published_version,
                date_of_entry: moment().format(),
                data_json: dataObj,
                native_association: nativeAssociation,
                linked_association: linkedAssociation,
                native_crf_type: linkCRF?.associationTerm.OID,
                linked_crf_type: selectedVisit.visit_crf.OID,
                file_data: fileData,
                creation_source: linkCRF?.eventData?.creation_source ? linkCRF?.eventData?.creation_source : 'TSDA',
                event_uuid: linkCRF?.eventData?.event_uuid
              });
            }

            reqPayload = {
              ...reqPayload,
              linked_crfs_data: prevLinkedData
            };
          } else {
            validation = true;
            dispatch(hideLoader());
            if (emptyFormRows.length == 0) {
              noDataEntryForms.push(linkCRF.associationTerm.OID);
              let prevErrorThere = false;
              filterErrorList = filterErrorList.map((obj: any, listindex: any) => {
                if (listindex === formindex && !prevErrorThere) {
                  prevErrorThere = true;
                  return { ...obj, isError: true };
                } else {
                  return obj;
                }
              });
              setlistOfcurrentSelectedLinkedCRFs(null);
              setlistOfcurrentSelectedLinkedCRFs(filterErrorList);
            }
          }
        }
      } else if (
        linkCRF.native_association == null ||
        linkCRF.native_crf_type == null ||
        linkCRF.associationTerm == null ||
        (linkCRF?.native_associationTermData && linkCRF?.native_associationTermData.trim() === '')
      ) {
        validation = true;
        if (noDataEntryForms.length == 0) {
          emptyFormRows.push(linkCRF);
          let prevErrorThere = false;
          filterErrorList = filterErrorList.map((obj: any, listindex: any) => {
            if (listindex === formindex && !prevErrorThere) {
              prevErrorThere = true;
              return { ...obj, isError: true };
            } else {
              return obj;
            }
          });
          setlistOfcurrentSelectedLinkedCRFs(null);
          setlistOfcurrentSelectedLinkedCRFs(filterErrorList);
        }
        dispatch(hideLoader());
        return;
      }
    });
    if (!validation) {
      if (reqPayload != null) {
        if (isUpdate && currentDataEntryFormId != null) {
          await updateCRFFormDataFunc({
            data: {
              ...reqPayload,
              id: currentDataEntryFormId,
              updated_by: user,
              visit_name: selectedVisit?.unscheduled_visit ? selectedVisit?.unscheduled_visit : null
            },
            study_id: studyId,
            site_id: selectedSite,
            country: selectedCountry
          });
          getQueries();
        } else {
          createCRFFormDataFunc({
            data: {
              ...reqPayload,
              visit_name: selectedVisit?.unscheduled_visit ? selectedVisit?.unscheduled_visit : null,
              created_by: user
            },
            study_id: studyId,
            site_id: selectedSite,
            country: selectedCountry
          });
        }
      }
      setTempField(tempField + 1);
    } else {
      dispatch(hideLoader());
      if (noDataEntryForms.length > 0) {
        dispatch(
          setMessage({
            msgDetails: `To save ${noDataEntryForms.toString()} must have at least one data entered field`,
            severity: 'error'
          })
        );
      } else {
        dispatch(
          setMessage({
            msgDetails: invalidData ? 'Invalid Data' : 'Missing mandatory data',
            severity: 'error'
          })
        );
      }
    }
    setSelectedIndex(null);
  };

  useEffect(() => {
    if (
      (!createCRFFormDataIsLoading && createCRFFormDataIsError) ||
      (!updateCRFFormDataIsLoading && updateCRFFormDataIsError)
    ) {
      dispatch(hideLoader());
      setisFieldChanged(false);
      const errorData: any = createCRFFormDataError ?? updateCRFFormDataError;
      handleError(errorData, true);
    }
    if (
      (!createCRFFormDataIsLoading && createCRFFormDataIsSuccess && createCRFFormData) ||
      (!updateCRFFormDataIsLoading && updateCRFFormDataIsSuccess && updateCRFFormData)
    ) {
      dispatch(hideLoader());
      setcurrentSelectedLinkedCRF(null);
      if (!createCRFFormDataIsLoading && createCRFFormDataIsSuccess && createCRFFormData) {
        getQueries();
        seteditRowData(createCRFFormData.result);
      } else if (
        !updateCRFFormDataIsLoading &&
        updateCRFFormDataIsSuccess &&
        updateCRFFormData &&
        updateCRFFormData?.result
      ) {
        seteditRowData(updateCRFFormData.result);
      }
      setisFieldChanged(false);
      if (!isUpdate) {
        (async () => {
          dispatch(showLoader());
          await getPatientsDetails({
            OID: selectedVisit.visit_crf.OID,
            parent_id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry
          });
          dispatch(hideLoader());
        })();
      } else {
        (async () => {
          dispatch(showLoader());
          if (selectedVisit?.visit_crf.OID && editRowData) {
            await selectCRFDataByID({
              data: {
                OID: selectedVisit.visit_crf.OID,
                patient_id: parent_id,
                event_uuid: editRowData?.event_uuid,
                visit_id: selectedVisit?.study_visit.id,
                creation_source: editRowData?.creation_source ? editRowData?.creation_source : 'TSDA'
              },
              site_id: selectedSite,
              study_id: studyId,
              country: selectedCountry
            });
            dispatch(hideLoader());
          }
        })();
      }
      dispatch(hideLoader());
      setisUpdate(true);
      setisAddCliked(false);
      //setselectedVisit(null);
      // setdataEntryNum(null);
      // dispatch(openCRFModel(false));
      if (exitValue) {
        setExitValue(false);
      }
      dispatch(
        setMessage({
          msgDetails: 'CRF saved successfully',
          severity: 'success'
        })
      );
    }
  }, [
    createCRFFormData,
    createCRFFormDataIsError,
    createCRFFormDataIsLoading,
    createCRFFormDataIsSuccess,
    createCRFFormDataError,
    updateCRFFormData,
    updateCRFFormDataIsSuccess,
    updateCRFFormDataError,
    updateCRFFormDataIsLoading,
    updateCRFFormDataIsError
  ]);
  const extractFields = (obj: any) => {
    if (obj) {
      const fields: any = [];
      obj.forEach((item: any) => {
        if (item.rows) {
          item.rows.forEach((row: any) => {
            if (row.fields) {
              fields.push(...row.fields);
            }
          });
        }
      });
      return fields;
    }
  };
  useEffect(() => {
    if (!isUpdate && listOfcurrentSelectedLinkedCRFs?.[0]?.associationTerm?.meta) {
      const fields = extractFields(listOfcurrentSelectedLinkedCRFs?.[0]?.associationTerm?.meta?.sections)?.find(
        (ele: any) => ele.type === 'time' && (ele.is_current_time || ele.default_value)
      );
      if (fields) {
        setisFieldChanged(true);
      }
    }
  }, [isUpdate, listOfcurrentSelectedLinkedCRFs]);

  useEffect(() => {
    if (selectedIndex) {
      submitAllForms();
      setAnchorEl(null);
      setConfirmExitValue(dispatch, false);
    }
  }, [selectedIndex]);

  /**
   * ADD NEW LINK CRF Functionality End
   */

  /**
   * Remove linked CRF start
   */
  const [openRemoveLinkCRF, setopenRemoveLinkCRF] = useState(false);
  const [currentRemoveLinkCRFEventNum, setcurrentRemoveLinkCRFEventNum] = useState(null);
  const [currentRemoveLinkCRFOID, setcurrentRemoveLinkCRFOID] = useState(null);

  const handleRemoveLinkedCRF = (eventNumber: any, eventOID: any) => {
    setcurrentRemoveLinkCRFEventNum(eventNumber);
    setcurrentRemoveLinkCRFOID(eventOID);
    setopenRemoveLinkCRF(true);
  };

  const handleCloseopenRemoveLinkCRF = () => {
    setopenRemoveLinkCRF(false);
  };

  const handleConfirmopenRemoveLinkCRF = async () => {
    setopenRemoveLinkCRF(false);
    if (currentRemoveLinkCRFEventNum) {
      const filteredCRFS = listOfcurrentSelectedLinkedCRFs.filter((linkedCRF: any, index: any) => {
        if (index != 0) {
          if (
            linkedCRF.event_number.toString().includes('linkCRF') &&
            linkedCRF.event_number != currentRemoveLinkCRFEventNum
          ) {
            return linkedCRF;
          } else if (linkedCRF.event_number != currentRemoveLinkCRFEventNum) {
            return linkedCRF;
          } else {
            const filteredAlreadySelectedEvents = alreadySelectedEvents.filter((event: any, index: any) => {
              if (event.event_uuid != linkedCRF?.eventData?.event_uuid) {
                return event;
              }
            });
            setalreadySelectedEvents(filteredAlreadySelectedEvents);
          }
        } else {
          return linkedCRF;
        }
      });
      setlistOfcurrentSelectedLinkedCRFs(filteredCRFS);
      setcurrentSelectedLinkedCRF(null);
    }
  };

  const [openRemoveLinkCRFEvent, setopenRemoveLinkCRFEvent] = useState(false);

  const [removeType, setremoveType] = useState('AssoOnly');

  const handleRemoveLinkedCRFEvent = (eventNumber: any, eventOID: any) => {
    setcurrentRemoveLinkCRFEventNum(eventNumber);
    setcurrentRemoveLinkCRFOID(eventOID);
    setopenRemoveLinkCRFEvent(true);
  };

  const handleCloseopenRemoveLinkCRFEvent = () => {
    setopenRemoveLinkCRFEvent(false);
  };

  const handleConfirmopenRemoveLinkCRFEvent = async () => {
    dispatch(showLoader());
    setopenRemoveLinkCRFEvent(false);
    const findCRF = listOfcurrentSelectedLinkedCRFs.find((linkedCRF: any) => {
      if (
        linkedCRF.event_number === currentRemoveLinkCRFEventNum &&
        linkedCRF.associationTerm.OID === currentRemoveLinkCRFOID
      ) {
        return linkedCRF;
      }
    });
    if (removeType == 'AssoOnly') {
      if (findCRF) {
        deleteAssociation({
          data: {
            patient_id: parent_id,
            visit_id: selectedVisit.study_visit.id,

            native_OID: selectedVisit.visit_crf.OID,
            native_crf_id: editRowData?.nativeCRFId,
            native_crf_form_version: selectedVisit.visit_crf.published_version,

            linked_OID: findCRF.eventData.native_crf_type,
            linked_crf_form_version: findCRF.eventData.crf_form_version,
            linked_crf_id: findCRF.eventData.id
          },
          study_id: studyId,
          site_id: selectedSite,
          country: selectedCountry
        });
      }
    } else {
      if (findCRF) {
        deleteAssociationEvent({
          data: {
            patient_id: parent_id,
            visit_id: selectedVisit.study_visit.id,

            native_OID: selectedVisit.visit_crf.OID,
            native_crf_id: editRowData?.nativeCRFId,
            native_crf_form_version: selectedVisit.visit_crf.published_version,

            linked_OID: findCRF.eventData.native_crf_type,
            linked_crf_form_version: findCRF.eventData.crf_form_version,
            linked_crf_id: findCRF.eventData.id
          },
          study_id: studyId,
          site_id: selectedSite,
          country: selectedCountry
        });
      }
    }
  };

  useEffect(() => {
    if (deleteAssociationIsSuccess || deleteAssociationEventIsSuccess) {
      if (currentRemoveLinkCRFEventNum) {
        (async () => {
          await getPatientsDetails({
            OID: selectedVisit.visit_crf.OID,
            parent_id,
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry
          });
          await selectCRFDataByID({
            data: {
              OID: selectedVisit.visit_crf.OID,
              patient_id: parent_id,
              event_uuid: editRowData?.event_uuid,
              visit_id: selectedVisit?.study_visit.id,
              creation_source: editRowData?.creation_source ? editRowData?.creation_source : 'TSDA'
            },
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry
          });
          setalreadySelectedEvents([]);
          setcurrentSelectedLinkedCRF(null);
          setcurrentAddedEvent(null);
          dispatch(hideLoader());
          if (removeType == 'AssoOnly') {
            dispatch(
              setMessage({
                msgDetails: 'CRF association link is removed successfully',
                severity: 'success'
              })
            );
          } else {
            dispatch(
              setMessage({
                msgDetails: 'CRF association link along with the event is removed successfully.',
                severity: 'success'
              })
            );
          }
          setremoveType('AssoOnly');
        })();
      }
    } else if (deleteAssociationIsError || deleteAssociationEventIsError) {
      setremoveType('AssoOnly');
      dispatch(hideLoader());
      dispatch(
        setMessage({
          msgDetails: 'Error in CRF association link.',
          severity: 'error'
        })
      );
    }
  }, [deleteAssociationIsSuccess, deleteAssociationEventIsSuccess]);

  /**
   * Remove linked CRF End
   */

  // view and forword Query code
  const handleContextMenu = (event: React.MouseEvent, data: any, filedType = 'Field') => {
    if (filedType === 'Row') {
      const filtered = raisedQuerys.filter(
        (ele: any) =>
          data.find((item: any) => item.key === ele.query.report_field_name) ||
          ((ele.query.report_section_name === null || ele.query.report_section_name === 'CRF') &&
            ele.query.report_query_type === 'Section')
      );
      setShowFields({ data });
      setShowQuerys([...filtered]);
      if (data.length === 1) {
        setQueryObj({ filedType: 'Field', filedData: data[0] });
      } else {
        setQueryObj({ filedType, filedData: data });
      }
      setOpenQueryDialog(true);
    } else if (filedType === 'Section') {
      const filtered = allQueries.filter((ele: any) =>
        data.find((item: any) => item.fields.find((elem: any) => elem.key == ele.query.report_field_name))
      );
      setShowFields({ data });
      setShowQuerys([...filtered]);
      setQueryObj({ filedType, filedData: data });
      setOpenQueryDialog(true);
      setIsSectionQuery(true);
    } else {
      event.preventDefault();
      setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
      setQueryObj({ filedType, filedData: data });
    }
  };
  const handleContextmenu = (key: string) => {
    if (key === 'raise_field_query') {
      setOpenRaiseQuery(true);
    }
    if (key === 'view_field_query') {
      if (queryObj?.filedData) {
        const filtered = raisedQuerys.filter((ele: any) => ele.query.report_field_name === queryObj.filedData.key);
        setShowFields({ data: key });
        setShowFieldKeys(key);
        setShowQuerys([...filtered]);
      }
      setOpenQueryDialog(true);
    }
    if (key === 'view_all_queries') {
      setShowFields({ data: key });
      setShowFieldKeys(key);
      setShowQuerys([...allQueries]);
      setOpenQueryDialog(true);
    }
    if (key === 'raise_section_query') {
      setShowFields({ data: key });
      setShowFieldKeys(key);
      setOpenRaiseQuery(true);
      setIsSectionQuery(true);
    }
    setContextMenu(null);
  };
  const {
    isLoading: getQueriesIsLoading,
    data: getQueriesData,
    isSuccess: getQueriesIsSuccess,
    refetch: getQueries
  } = useGetQueriesQuery({
    site_id: selectedSite || '',
    study_id: studyId || '',
    country: selectedCountry || '',
    application: process.env.REACT_APP_NAME,
    application_section: 'CONDUCT',
    application_module_section: 'CRFENTRY'
  });
  useEffect(() => {
    if (getQueriesData && getQueriesIsSuccess && !getQueriesIsLoading) {
      const data: any = JSON.parse(JSON.stringify(getQueriesData));
      const allQueries = data.filter(
        (ele: any) => ele?.query?.report_category === 'CRFFLDQRY' && editRowData?.event_uuid === ele?.query?.report_id
      );
      const filtered = data.filter((ele: any) => editRowData?.event_uuid === ele?.query?.report_id);
      const sectionFiltered = data.filter(
        (ele: any) => ele?.query?.report_query_type === 'Section' && editRowData?.event_uuid === ele?.query?.report_id
      );
      setAllQueries(allQueries);
      setRaisedQuerys(filtered);
      setSectionQuerys(sectionFiltered);
      if (showFieldKeys === 'view_field_query') {
        const filteredNew = filtered.filter((ele: any) => ele.query.report_field_name === queryObj.filedData.key);
        setShowQuerys(filteredNew);
      } else if (showFieldKeys === 'view_all_queries') {
        setShowQuerys(allQueries);
      } else if (showFieldKeys === 'raise_section_query') {
        setShowQuerys(allQueries);
      } else if (showFields?.data) {
        const filteredNew = filtered.filter((ele: any) =>
          showFields?.data.find((item: any) => item.key === ele.query.report_field_name)
        );
        setShowQuerys([...filteredNew]);
      }
    }
  }, [getQueriesData, getQueriesIsSuccess, getQueriesIsLoading, editRowData?.event_uuid]);

  const handleContaxtClose = () => {
    setContextMenu(null);
  };
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (
      selectCRFDataByIDIsLoading ||
      listOfcurrentSelectedLinkedCRFs === null ||
      getPatientsDetailsIsLoading ||
      getCRFEventIsLoading
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [selectCRFDataByIDIsLoading, listOfcurrentSelectedLinkedCRFs, getPatientsDetailsIsLoading, getCRFEventIsLoading]);
  return (
    <Box className="formCRFHistoryModal" pb={8}>
      {!isLoading && <Loader />}
      {isLoading ? (
        <Box display={'flex'} justifyContent={'center'} alignContent={'center'} height={'80vh'}>
          <ContentLoader />
        </Box>
      ) : (
        <Grid container spacing={2} className="formCRFHistoryModal_MainGrid" sx={{ minHeight: '490px' }}>
          <Grid
            item
            xs={
              listOfcurrentSelectedLinkedCRFs &&
              listOfcurrentSelectedLinkedCRFs.length > 1 &&
              currentSelectedLinkedCRF != null
                ? 6
                : 12
            }
          >
            <Tooltip
              placement="bottom"
              arrow
              title={
                bookMarkField?.title.length > 200 && bookMarkField?.fieldKey == 'label' ? bookMarkField.title : null
              }
            >
              <Typography
                variant="h5"
                component="h5"
                mb={3}
                mt={-1}
                sx={{
                  fontWeight: '500',
                  minHeight: '28px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  '-webkitLineClamp': '6',
                  '-webkitBoxOrient': 'vertical',
                  maxWidth: 'calc(100% - 20px)',
                  position: 'relative'
                }}
                className="crfFormFirstTitle"
              >
                {/** Auto bind bookmark value for parent form */}
                {dataEntryNum ? dataEntryNum : ''}
                {listOfcurrentSelectedLinkedCRFs != null &&
                listOfcurrentSelectedLinkedCRFs.length > 0 &&
                listOfcurrentSelectedLinkedCRFs[0]?.initialValues &&
                (listOfcurrentSelectedLinkedCRFs[0]?.initialValues[bookMarkKey] || bookMarkField?.fieldKey == 'label')
                  ? bookMarkField?.cmp == 'date'
                    ? bookMarkField?.type == 'date_time'
                      ? `. ${moment(new Date(listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey])).format(
                          `${userPreferedDateFormat.toUpperCase()} h:mm A`
                        )}`
                      : `. ${moment(listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]).format(
                          `${userPreferedDateFormat.toUpperCase()}`
                        )}`
                    : bookMarkField?.cmp == 'time'
                    ? `. ${
                        listOfcurrentSelectedLinkedCRFs[0]?.initialValues?.[bookMarkKey] === 'Invalid Time'
                          ? listOfcurrentSelectedLinkedCRFs[0]?.eventData?.[bookMarkKey].toString() || ''
                          : listOfcurrentSelectedLinkedCRFs[0]?.initialValues?.[bookMarkKey].toString() || ''
                      }`
                    : bookMarkField?.cmp == 'select' &&
                      bookMarkField?.multiple &&
                      typeof listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey] === 'object' &&
                      listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]?.length &&
                      listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]?.find(
                        (item: any) => 'label' in item
                      )
                    ? `. ${listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]
                        ?.map((value: any) => value?.label)
                        ?.toString()}`
                    : bookMarkField?.cmp == 'select' &&
                      typeof listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey] === 'object' &&
                      listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]?.label
                    ? `. ${listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]?.label}`
                    : bookMarkField?.cmp == 'checkbox'
                    ? `. ${getCheckboxValue(
                        bookMarkField,
                        listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]
                      )}`
                    : bookMarkField?.cmp == 'radio'
                    ? `. ${getRadioButtonValue(
                        bookMarkField,
                        listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]
                      )}`
                    : listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey] != undefined
                    ? `. ${listOfcurrentSelectedLinkedCRFs[0].initialValues[bookMarkKey]?.toString()}`
                    : bookMarkField?.fieldKey == 'label'
                    ? `${'. '}${bookMarkField?.title}`
                    : null
                  : null}

                {bookMarkKey &&
                editRowData &&
                bookMarkKey in editRowData &&
                (editRowData[bookMarkKey] != null || bookMarkField?.fieldKey == 'label') ? (
                  <BookmarkIcon style={{ marginTop: '2px', height: '20px', width: '20px', marginLeft: '5px' }} />
                ) : (
                  ''
                )}
              </Typography>
            </Tooltip>
            {tempField && listOfcurrentSelectedLinkedCRFs != null && listOfcurrentSelectedLinkedCRFs.length > 0 ? (
              <div style={{ marginLeft: '-16px' }}>
                <DJ2Form
                  formId={listOfcurrentSelectedLinkedCRFs[0].event_number}
                  key={tempField}
                  ref={listOfcurrentSelectedLinkedCRFs[0].formRefObj}
                  initialValues={{
                    ...listOfcurrentSelectedLinkedCRFs[0].initialValues,
                    formId: listOfcurrentSelectedLinkedCRFs[0].event_number
                  }}
                  eventData={{ OID: listOfcurrentSelectedLinkedCRFs[0].associationTerm.OID }}
                  rules={listOfcurrentSelectedLinkedCRFs[0].rules}
                  formConfig={listOfcurrentSelectedLinkedCRFs[0].associationTerm.meta}
                  onChange={onDJ2Change}
                  formIndex={0}
                  handleContextMenu={handleContextMenu}
                  queryActive={checkPermission('view_crf_queries')}
                  queryArray={raisedQuerys}
                  sectionActive={checkPermission('view_crf_queries') && sectionQuerys.length > 0}
                  sectionArray={sectionQuerys}
                />
                {QueryMenu.length ? (
                  <Menu
                    open={contextMenu !== null}
                    onClose={handleContaxtClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
                    }
                    className="contextMenu_biggerFont"
                  >
                    {QueryMenu.map((ele: any) => (
                      <MenuItem key={ele.key} onClick={() => handleContextmenu(ele.key)}>
                        {ele.displayName}
                      </MenuItem>
                    ))}
                  </Menu>
                ) : null}
                <ViewQuery
                  setOpenQueryDialog={setOpenQueryDialog}
                  openQueryDialog={openQueryDialog}
                  openRaiseQuery={openRaiseQuery}
                  setOpenRaiseQuery={setOpenRaiseQuery}
                  queryObj={queryObj}
                  setQueryObj={setQueryObj}
                  id={editRowData?.event_uuid || ''}
                  raisedQuerys={raisedQuerys}
                  showQuerys={showQuerys}
                  getQueries={getQueries}
                  getQueriesIsLoading={getQueriesIsLoading}
                  openFieldAuditTrail={openFieldAuditTrail}
                  setOpenFieldAuditTrail={setOpenFieldAuditTrail}
                  isSectionQuery={isSectionQuery}
                  setIsSectionQuery={setIsSectionQuery}
                />
              </div>
            ) : null}

            <Grid item md={12}>
              <div style={{ maxHeight: '28vh', overflowY: 'auto' }}>
                {listOfcurrentSelectedLinkedCRFs != null &&
                  listOfcurrentSelectedLinkedCRFs.map((item: any, index: any) => {
                    if (index > 0) {
                      return (
                        <div
                          key={`listOfcurrentSelectedLinkedCRFs${index}`}
                          style={{ margin: '1px 0' }}
                          className={
                            currentSelectedLinkedCRF != null &&
                            currentSelectedLinkedCRF?.associationTerm != null &&
                            item?.associationTerm?.OID != null &&
                            currentSelectedLinkedCRF?.associationTerm?.OID == item?.associationTerm?.OID &&
                            currentSelectedLinkedCRF?.event_number == item?.event_number &&
                            !item?.isError
                              ? 'selectedCRFRow'
                              : item?.isError
                              ? 'errorInCRFRow'
                              : ''
                          }
                        >
                          <Grid container spacing={2} className="add_delete_FormGrid">
                            <Grid item xs>
                              <Grid container spacing={2} rowSpacing={0} key={item.event_number}>
                                <Grid item md={4}>
                                  <FormControl
                                    fullWidth
                                    variant="standard"
                                    disabled={item.associationTerm != null ? true : false}
                                    required
                                  >
                                    <InputLabel id={`label_Association${item.event_number}`}>Association</InputLabel>
                                    <Select
                                      key={item.event_number}
                                      labelId={`label_Association${item.event_number}`}
                                      id={`Association${item.event_number}`}
                                      value={item.native_association ? item.native_association.trim() : null}
                                      label="Association *"
                                      name="native_association"
                                      onChange={(event: any) =>
                                        handleChangeAssociation(event, item.event_number, item.native_crf_type)
                                      }
                                    >
                                      {crfASSOCIATIONData && crfASSOCIATIONData.length > 0
                                        ? crfASSOCIATIONData.map((obj: any) => {
                                            return (
                                              <MenuItem
                                                key={obj.code_list_value.trim()}
                                                value={obj.code_list_value.trim()}
                                              >
                                                {obj.code_list_value.trim()}
                                              </MenuItem>
                                            );
                                          })
                                        : null}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={4}>
                                  <FormControl
                                    fullWidth
                                    variant="standard"
                                    disabled={item.associationTerm != null ? true : false}
                                    required
                                  >
                                    <InputLabel id={`label_CRFType${item.event_number}`}>CRF</InputLabel>
                                    <Select
                                      key={item.event_number}
                                      labelId={`label_CRFType${item.event_number}`}
                                      id={`CRFType${item.event_number}`}
                                      value={item.native_crf_type}
                                      label="CRF *"
                                      name="native_crf_type"
                                    >
                                      {getVisitLinkedCRFsData &&
                                        selectedVisit &&
                                        getVisitLinkedCRFsData.map((obj: any) => {
                                          if (obj.OID !== selectedVisit.visit_crf.OID) {
                                            return (
                                              <MenuItem
                                                onClick={() =>
                                                  handleChangeAssociation(
                                                    {
                                                      target: {
                                                        name: 'native_crf_type',
                                                        value: obj.OID,
                                                        version: obj.published_version
                                                      }
                                                    },
                                                    item.event_number,
                                                    item.native_crf_type
                                                  )
                                                }
                                                key={obj.OID}
                                                value={obj.OID}
                                              >
                                                {obj.custom_name ?? obj.OID}
                                              </MenuItem>
                                            );
                                          }
                                        })}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={4}>
                                  {item?.optionsData && item?.optionsData.length > 0 ? (
                                    item?.associationTermEventData &&
                                    (item?.associationTermEventData?.value == 'NEW' ||
                                      item?.associationTermEventData?.value == '' ||
                                      item?.associationTermEventData?.value == null) ? (
                                      <TextField
                                        InputProps={{
                                          readOnly: true
                                        }}
                                        value=""
                                        required
                                        sx={{ '& .MuiInputBase-readOnly': { cursor: 'pointer' } }}
                                        id="text_association_term"
                                        label="Association Term"
                                        variant="standard"
                                        onClick={() =>
                                          handleChangeAssociation(
                                            {
                                              target: {
                                                name: 'associationTermEvent',
                                                value: [item.associationTermEventData]
                                              }
                                            },
                                            item.event_number,
                                            item.native_crf_type
                                          )
                                        }
                                      />
                                    ) : (
                                      <Autocomplete
                                        key={`native_association_event_${item.event_number}`}
                                        id={`native_association_event_${item.event_number}`}
                                        onChange={(event: any, value: any) =>
                                          handleChangeAssociation(
                                            { target: { name: 'associationTermEvent', value } },
                                            item.event_number,
                                            item.native_crf_type
                                          )
                                        }
                                        disabled={
                                          item.native_association == null || item.native_crf_type == null ? true : false
                                        }
                                        readOnly={item.associationTermEventData ? true : false}
                                        value={
                                          item?.associationTermEventData
                                            ? item.associationTermEventData.value == 'NEW'
                                              ? []
                                              : [item.associationTermEventData]
                                            : []
                                        }
                                        options={item.optionsData}
                                        filterSelectedOptions
                                        getOptionDisabled={option => {
                                          const findOption = alreadySelectedEvents.find((dataEvent: any) => {
                                            if (
                                              option.label == dataEvent.label &&
                                              option.id == dataEvent.id &&
                                              option.OID == dataEvent.OID
                                            ) {
                                              return dataEvent;
                                            }
                                          });
                                          if (findOption) {
                                            return true;
                                          } else {
                                            return false;
                                          }
                                        }}
                                        //getOptionDisabled={true}
                                        autoComplete
                                        limitTags={1}
                                        multiple
                                        renderTags={(value, getTagProps) =>
                                          value.map((option: any, index: number) => (
                                            <Chip
                                              onClick={(event: any) => {
                                                handleChangeAssociation(
                                                  {
                                                    target: { name: 'associationTermEvent', value: [option] }
                                                  },
                                                  item.event_number,
                                                  item.native_crf_type
                                                );
                                              }}
                                              variant="outlined"
                                              size="small"
                                              label={option?.label}
                                              {...getTagProps({ index })}
                                              key={index}
                                            />
                                          ))
                                        }
                                        renderInput={params => (
                                          <TextField
                                            onClick={(event: any) => {
                                              if (
                                                item?.associationTermEventData &&
                                                item?.associationTermEventData.value == 'NEW'
                                              ) {
                                                handleChangeAssociation(
                                                  {
                                                    target: {
                                                      name: 'associationTermEvent',
                                                      value: [
                                                        item.optionsData.find((option: any) => option.key == 'newId')
                                                      ]
                                                    }
                                                  },
                                                  item.event_number,
                                                  item.native_crf_type
                                                );
                                              }
                                            }}
                                            required
                                            className="autoCompleteFakechip"
                                            variant="standard"
                                            {...params}
                                            id="auto-complete-field"
                                            name="associationTermEvent"
                                            label="Association Term"
                                          />
                                        )}
                                        className="autoCompletewSmallChip"
                                      />
                                    )
                                  ) : (
                                    <Autocomplete
                                      key={item.event_number}
                                      disabled={
                                        item.native_association == null || item.native_crf_type == null ? true : false
                                      }
                                      id={`native_association${item.event_number}`}
                                      options={
                                        item?.native_associationTermData ? [item.native_associationTermData] : []
                                      }
                                      defaultValue={
                                        item?.native_associationTermData ? [item.native_associationTermData] : []
                                      }
                                      value={item?.native_associationTermData ? [item.native_associationTermData] : []}
                                      autoComplete
                                      limitTags={1}
                                      readOnly
                                      multiple
                                      renderTags={(value, getTagProps) =>
                                        value.map((option: string, index: number) => (
                                          <Chip
                                            onClick={() => {
                                              if (item?.native_associationTermData) {
                                                handleChangeAssociation(
                                                  { target: { name: 'associationTerm' } },
                                                  item.event_number,
                                                  item.native_crf_type
                                                );
                                              }
                                            }}
                                            variant="outlined"
                                            size="small"
                                            label={option}
                                            {...getTagProps({ index })}
                                            key={index}
                                          />
                                        ))
                                      }
                                      renderInput={params => (
                                        <TextField
                                          onClick={(event: any) => {
                                            if (!item?.native_associationTermData) {
                                              handleChangeAssociation(event, item.event_number, item.native_crf_type);
                                            }
                                          }}
                                          required
                                          name="associationTerm"
                                          label="Association Term"
                                          variant="standard"
                                          {...params}
                                        />
                                      )}
                                      className="autoCompletewSmallChip"
                                    />
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item pr={2}>
                              <IconButton
                                disabled={!checkPermission('add_crf_entry')}
                                onClick={() =>
                                  item.event_number.toString().includes('linkCRF')
                                    ? handleRemoveLinkedCRF(item.event_number, item?.native_crf_type)
                                    : handleRemoveLinkedCRFEvent(item.event_number, item?.native_crf_type)
                                }
                                key={item.event_number}
                                aria-label="Help"
                                sx={{ mt: 2 }}
                                size="small"
                              >
                                <CloseIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </div>
                      );
                    }
                  })}
              </div>
              {listOfcurrentSelectedLinkedCRFs != null &&
              listOfcurrentSelectedLinkedCRFs.length > 0 &&
              listOfcurrentSelectedLinkedCRFs[0].associationTerm?.add_new_link_crf ? (
                <Grid item md={12} pt={1}>
                  <Button
                    disabled={!checkPermission('add_crf_entry')}
                    onClick={handlAddNewLinkCRFBtn}
                    startIcon={<AddIcon />}
                  >
                    Add New Link CRF
                  </Button>
                  <IconButton sx={{ display: 'none' }}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
          {currentSelectedLinkedCRF != null &&
          listOfcurrentSelectedLinkedCRFs &&
          listOfcurrentSelectedLinkedCRFs.length > 1
            ? listOfcurrentSelectedLinkedCRFs.map((linkedCrf: any, index: any) => {
                if (
                  linkedCrf.associationTerm != null &&
                  index > 0 &&
                  currentSelectedLinkedCRF?.associationTerm?.OID == linkedCrf?.associationTerm.OID &&
                  currentSelectedLinkedCRF?.event_number == linkedCrf?.event_number &&
                  currentSelectedLinkedCRF?.event_uuid == linkedCrf?.event_uuid
                ) {
                  return (
                    <Grid className="crfModal-rightForm" mt={-4} pt={3} key={linkedCrf.associationTerm.OID} item xs={6}>
                      <Typography variant="h5" component="h5" my={3} sx={{ fontWeight: '500' }}>
                        {linkedCrf?.associationTerm?.custom_name ?? linkedCrf?.associationTerm?.meta?.title}
                      </Typography>
                      <DJ2Form
                        formIndex={index}
                        formId={linkedCrf.event_number}
                        eventData={{
                          OID: listOfcurrentSelectedLinkedCRFs[0].associationTerm.OID,
                          ...linkedCrf.eventData
                        }}
                        key={linkedCrf.event_number + linkedCrf.OID}
                        ref={linkedCrf.formRefObj}
                        initialValues={{
                          ...linkedCrf.initialValues,
                          formId: linkedCrf.event_number,
                          linked_association: linkedCrf?.linked_association
                            ? linkedCrf.linked_association.trim()
                            : null,
                          native_association: linkedCrf?.native_association
                            ? linkedCrf.native_association.trim()
                            : null,
                          eventData: linkedCrf.eventData
                        }}
                        rules={linkedCrf.rules || linkedCrf.rulesCopy}
                        formConfig={linkedCrf.associationTerm.meta}
                        onChange={onDJ2Change}
                        linked_association={linkedCrf?.linked_association ? linkedCrf.linked_association.trim() : null}
                        native_association={linkedCrf?.native_association ? linkedCrf.native_association.trim() : null}
                      />
                      {linkedCrf?.linkedData && linkedCrf?.linkedData.linked_crfs_data.length > 0
                        ? linkedCrf?.linkedData.linked_crfs_data.map((data: any, index: number) => {
                            const chailBookmarkdata =
                              data?.bookmark_key &&
                              (data?.bookmark_key_value || data?.bookmark_cmp?.fieldKey == 'label')
                                ? data?.bookmark_cmp?.cmp == 'date'
                                  ? data?.bookmark_cmp?.type == 'date_time'
                                    ? moment(new Date(data?.bookmark_key_value)).format(
                                        `${userPreferedDateFormat.toUpperCase()} h:mm A`
                                      )
                                    : moment(data?.bookmark_key_value).format(`${userPreferedDateFormat.toUpperCase()}`)
                                  : data?.bookmark_cmp?.cmp == 'time'
                                  ? data?.bookmark_key_value
                                  : data?.bookmark_cmp?.cmp == 'radio'
                                  ? getRadioButtonValue(data?.bookmark_cmp, data?.bookmark_key_value)
                                  : data?.bookmark_cmp?.fieldKey && data?.bookmark_cmp?.fieldKey == 'label'
                                  ? data?.bookmark_cmp?.title
                                  : data?.bookmark_cmp?.cmp == 'checkbox'
                                  ? getCheckboxValue(data?.bookmark_cmp, data?.bookmark_key_value)
                                  : data?.bookmark_cmp?.cmp == 'select' &&
                                    data?.bookmark_cmp?.multiple &&
                                    typeof data.bookmark_key_value === 'object' &&
                                    'key' in data.bookmark_key_value
                                  ? data?.bookmark_key_value?.key.map((value: any) => value.label).toString()
                                  : data?.bookmark_cmp?.cmp == 'select' && typeof data.bookmark_key_value === 'object'
                                  ? data.bookmark_key_value?.label
                                  : data.bookmark_key_value.toString()
                                : `${data.event_number} (${moment(new Date(data.date_of_entry)).format(
                                    `${userPreferedDateFormat.toUpperCase()}`
                                  )})`;
                            return (
                              <Box sx={{ px: 2, mt: 2 }} key={`linkedDatalinked_crfs${index}`}>
                                <Grid container spacing={2} className="add_delete_FormGrid">
                                  <Grid item xs>
                                    <Grid container spacing={2}>
                                      <Grid item md={4}>
                                        <FormControl fullWidth variant="standard">
                                          <InputLabel id={`label_Association${linkedCrf.event_number}`}>
                                            Association *
                                          </InputLabel>
                                          <Select
                                            disabled
                                            required
                                            key={data.event_number + data.OID}
                                            labelId={`label_Association${data.event_number}`}
                                            id={`demo_Association${data.event_number}`}
                                            value={data?.native_association}
                                            label="Association *"
                                            name="native_association"
                                          >
                                            <MenuItem key={data?.native_association} value={data?.native_association}>
                                              {data?.native_association}
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                      <Grid item md={4}>
                                        <FormControl fullWidth variant="standard">
                                          <InputLabel id={`label_CRFType${data.event_number}`}>CRF *</InputLabel>
                                          <Select
                                            required
                                            disabled
                                            key={data.event_number + data.OID}
                                            labelId={`label_CRFType${data.event_number}`}
                                            id={`demo_CRFType${data.event_number}`}
                                            value={data.native_crf_type}
                                            label="CRF *"
                                            name="native_crf_type"
                                          >
                                            <MenuItem key={data.native_crf_type} value={data.native_crf_type}>
                                              {data.native_crf_type}
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                      <Grid item md={4}>
                                        <Autocomplete
                                          disabled
                                          key={data.event_number + data.OID}
                                          id={`tags-standard${data.event_number}`}
                                          options={[chailBookmarkdata]}
                                          defaultValue={[chailBookmarkdata]}
                                          value={[chailBookmarkdata]}
                                          autoComplete
                                          limitTags={1}
                                          readOnly
                                          multiple
                                          renderTags={(value, getTagProps) =>
                                            value.map((option: string, index: number) => (
                                              <Chip
                                                variant="outlined"
                                                size="small"
                                                label={option}
                                                {...getTagProps({ index })}
                                                key={index}
                                              />
                                            ))
                                          }
                                          renderInput={params => (
                                            <TextField
                                              required
                                              name="associationTerm"
                                              label="Association Term"
                                              variant="standard"
                                              {...params}
                                            />
                                          )}
                                          className="autoCompletewSmallChip"
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item>
                                    <IconButton
                                      disabled
                                      key={linkedCrf.event_number}
                                      aria-label="Help"
                                      sx={{ mt: 2 }}
                                      size="small"
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </Box>
                            );
                          })
                        : null}
                      {linkedCrf?.isNewlyAdded === true ? (
                        <Box sx={{ px: 2, mt: 2 }}>
                          <Grid container spacing={2} className="add_delete_FormGrid">
                            <Grid item xs>
                              <Grid container spacing={2}>
                                <Grid item md={4}>
                                  <FormControl fullWidth variant="standard">
                                    <InputLabel id={`label_Association${linkedCrf.event_number}`}>
                                      Association *
                                    </InputLabel>
                                    <Select
                                      required
                                      key={linkedCrf.event_number + linkedCrf.OID}
                                      labelId={`label_Association${linkedCrf.event_number}`}
                                      id={`demo_Association${linkedCrf.event_number}`}
                                      value={linkedCrf?.linked_association ? linkedCrf.linked_association.trim() : null}
                                      label="Association *"
                                      name="linked_association"
                                      onChange={(event: any) =>
                                        handleChangeAssociation(
                                          event,
                                          linkedCrf.event_number,
                                          linkedCrf.native_crf_type
                                        )
                                      }
                                    >
                                      {crfASSOCIATIONData && crfASSOCIATIONData.length > 0
                                        ? crfASSOCIATIONData.map((obj: any) => {
                                            return (
                                              <MenuItem
                                                key={obj.code_list_value.trim()}
                                                value={obj.code_list_value.trim()}
                                              >
                                                {obj.code_list_value.trim()}
                                              </MenuItem>
                                            );
                                          })
                                        : null}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={4}>
                                  <FormControl fullWidth variant="standard">
                                    <InputLabel id={`label_CRFType${linkedCrf.event_number}`}>CRF *</InputLabel>
                                    <Select
                                      required
                                      disabled
                                      key={linkedCrf.event_number + linkedCrf.OID}
                                      labelId={`label_CRFType${linkedCrf.event_number}`}
                                      id={`demo_CRFType${linkedCrf.event_number}`}
                                      value={linkedCrf.linked_crf_type}
                                      label="CRF *"
                                      name="linked_crf_type"
                                    >
                                      {getVisitLinkedCRFsData &&
                                        selectedVisit &&
                                        getVisitLinkedCRFsData.map((obj: any) => {
                                          return (
                                            <MenuItem key={obj.OID} value={obj.OID}>
                                              {obj?.custom_name ?? obj.OID}
                                            </MenuItem>
                                          );
                                        })}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={4}>
                                  <Autocomplete
                                    disabled
                                    key={linkedCrf.event_number + linkedCrf.OID}
                                    id={`tags-standard${linkedCrf.event_number}`}
                                    options={linkedCrf?.associationTermData ? [linkedCrf.associationTermData] : []}
                                    defaultValue={linkedCrf?.associationTermData ? [linkedCrf.associationTermData] : []}
                                    value={linkedCrf?.associationTermData ? [linkedCrf.associationTermData] : []}
                                    autoComplete
                                    limitTags={1}
                                    readOnly
                                    multiple
                                    renderTags={(value, getTagProps) =>
                                      value.map((option: string, index: number) => (
                                        <Chip
                                          variant="outlined"
                                          size="small"
                                          label={option}
                                          {...getTagProps({ index })}
                                          key={index}
                                        />
                                      ))
                                    }
                                    renderInput={params => (
                                      <TextField
                                        required
                                        name="associationTerm"
                                        label="Association Term"
                                        variant="standard"
                                        {...params}
                                      />
                                    )}
                                    className="autoCompletewSmallChip"
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item>
                              <IconButton
                                disabled
                                key={linkedCrf.event_number}
                                aria-label="Help"
                                sx={{ mt: 2 }}
                                size="small"
                              >
                                <CloseIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Box>
                      ) : null}

                      {linkedCrf.associationTerm?.add_new_link_crf ? (
                        <Grid item md={12} pt={1}>
                          <Button disabled onClick={handlAddNewLinkCRFBtn} startIcon={<AddIcon />}>
                            Add New Link CRF
                          </Button>
                        </Grid>
                      ) : null}
                    </Grid>
                  );
                }
              })
            : null}
        </Grid>
      )}

      <Grid container className="ModalFooterRow" mb={-8}>
        <Grid item xs={9} />
        <Grid item xs={3} className="rightAlignBtns">
          <Button onClick={handleCloseModel} variant="text">
            Close
          </Button>
          <Button disabled={!isFieldChanged && checkPermission('add_crf_entry')} onClick={handleClick} variant="text">
            Save As
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'center'
            }}
            sx={{ marginTop: '-50px' }}
          >
            <List sx={{ width: '100%', maxWidth: 280, bgcolor: 'background.paper', padding: 0 }}>
              {codeListData && codeListData.length > 0
                ? codeListData
                    .filter((obj: any) => obj.code_list_value !== 'Deleted')
                    .map((obj: any) => {
                      return (
                        <>
                          <ListItem sx={{ padding: '0px' }} alignItems="flex-start">
                            <ListItemButton
                              selected={selectedIndex === obj.code_list_value}
                              onClick={() => handleListItemClick(obj.code_list_value)}
                            >
                              <ListItemText
                                primary={obj.code_list_value}
                                secondary={
                                  <>
                                    {obj.code_list_value == 'Complete'
                                      ? ' All necessary fields have been filled out and complete'
                                      : 'CRF will be completed at a later time'}
                                  </>
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                          <Divider component="li" />
                        </>
                      );
                    })
                : null}
            </List>
          </Popover>
        </Grid>
      </Grid>

      <Dialog
        open={openRemoveLinkCRFEvent}
        onClose={handleCloseopenRemoveLinkCRFEvent}
        aria-labelledby="Remove CRF Modal"
        aria-describedby=""
      >
        <DialogTitle id="alert-dialog-title">{'Remove CRF Link'}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Please select one of the below option to remove the CRF association.
          </Typography>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              //defaultValue="AssoOnly"
              name="radio-buttons-group"
              value={removeType}
              onChange={e => setremoveType(e.target.value)}
            >
              <FormControlLabel value="AssoOnly" control={<Radio />} label="Association Only" />
              <FormControlLabel value="AssoEvent" control={<Radio />} label="Association & Event" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseopenRemoveLinkCRFEvent} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleConfirmopenRemoveLinkCRFEvent} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRemoveLinkCRF}
        onClose={handleCloseopenRemoveLinkCRF}
        aria-labelledby="Remove CRF Modal"
        aria-describedby=""
      >
        <DialogTitle id="alert-dialog-title" />
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Are you sure to remove the CRF link?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseopenRemoveLinkCRF} className="grey-btn">
            NO
          </Button>
          <Button onClick={handleConfirmopenRemoveLinkCRF} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CRFFormModal;
